// This file is autogenerated, all your changes will be overwritten!
// If you want to change anything go to /tools/hl7/src/fields.ts and adjust the template!
import { HL7MessageSubfields } from './messageSubfields';
export const HL7MessageSegments: {
  id: string;
  description: string;
  subfields: keyof typeof HL7MessageSubfields;
}[] = [
  { id: 'ABS.1', description: 'Discharge Care Provider', subfields: 'XCN' },
  {
    id: 'ABS.2',
    description: 'Transfer Medical Service Code',
    subfields: 'CE',
  },
  { id: 'ABS.3', description: 'Severity of Illness Code', subfields: 'CE' },
  { id: 'ABS.4', description: 'Date/Time of Attestation', subfields: 'TS' },
  { id: 'ABS.5', description: 'Attested By', subfields: 'XCN' },
  { id: 'ABS.6', description: 'Triage Code', subfields: 'CE' },
  {
    id: 'ABS.7',
    description: 'Abstract Completion Date/Time',
    subfields: 'TS',
  },
  { id: 'ABS.8', description: 'Abstracted By', subfields: 'XCN' },
  { id: 'ABS.9', description: 'Case Category Code', subfields: 'CE' },
  { id: 'ABS.10', description: 'Caesarian Section Indicator', subfields: 'ID' },
  { id: 'ABS.11', description: 'Gestation Category Code', subfields: 'CE' },
  { id: 'ABS.12', description: 'Gestation Period - Weeks', subfields: 'NM' },
  { id: 'ABS.13', description: 'Newborn Code', subfields: 'CE' },
  { id: 'ABS.14', description: 'Stillborn Indicator', subfields: 'ID' },
  { id: 'ACC.1', description: 'Accident Date/Time', subfields: 'TS' },
  { id: 'ACC.2', description: 'Accident Code', subfields: 'CE' },
  { id: 'ACC.3', description: 'Accident Location', subfields: 'ST' },
  { id: 'ACC.4', description: 'Auto Accident State', subfields: 'CE' },
  {
    id: 'ACC.5',
    description: 'Accident Job Related Indicator',
    subfields: 'ID',
  },
  { id: 'ACC.6', description: 'Accident Death Indicator', subfields: 'ID' },
  { id: 'ACC.7', description: 'Entered By', subfields: 'XCN' },
  { id: 'ACC.8', description: 'Accident Description', subfields: 'ST' },
  { id: 'ACC.9', description: 'Brought In By', subfields: 'ST' },
  { id: 'ACC.10', description: 'Police Notified Indicator', subfields: 'ID' },
  { id: 'ACC.11', description: 'Accident Address', subfields: 'XAD' },
  {
    id: 'ADD.1',
    description: 'Addendum Continuation Pointer',
    subfields: 'ST',
  },
  { id: 'AFF.1', description: 'Set ID - AFF', subfields: 'SI' },
  { id: 'AFF.2', description: 'Professional Organization', subfields: 'XON' },
  {
    id: 'AFF.3',
    description: 'Professional Organization Address',
    subfields: 'XAD',
  },
  {
    id: 'AFF.4',
    description: 'Professional Organization Affiliation Date Range',
    subfields: 'DR',
  },
  {
    id: 'AFF.5',
    description: 'Professional Affiliation Additional Information',
    subfields: 'ST',
  },
  { id: 'AIG.1', description: 'Set ID - AIG', subfields: 'SI' },
  { id: 'AIG.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'AIG.3', description: 'Resource ID', subfields: 'CE' },
  { id: 'AIG.4', description: 'Resource Type', subfields: 'CE' },
  { id: 'AIG.5', description: 'Resource Group', subfields: 'CE' },
  { id: 'AIG.6', description: 'Resource Quantity', subfields: 'NM' },
  { id: 'AIG.7', description: 'Resource Quantity Units', subfields: 'CE' },
  { id: 'AIG.8', description: 'Start Date/Time', subfields: 'TS' },
  { id: 'AIG.9', description: 'Start Date/Time Offset', subfields: 'NM' },
  {
    id: 'AIG.10',
    description: 'Start Date/Time Offset Units',
    subfields: 'CE',
  },
  { id: 'AIG.11', description: 'Duration', subfields: 'NM' },
  { id: 'AIG.12', description: 'Duration Units', subfields: 'CE' },
  { id: 'AIG.13', description: 'Allow Substitution Code', subfields: 'IS' },
  { id: 'AIG.14', description: 'Filler Status Code', subfields: 'CE' },
  { id: 'AIL.1', description: 'Set ID - AIL', subfields: 'SI' },
  { id: 'AIL.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'AIL.3', description: 'Location Resource ID', subfields: 'PL' },
  { id: 'AIL.4', description: 'Location Type-AIL', subfields: 'CE' },
  { id: 'AIL.5', description: 'Location Group', subfields: 'CE' },
  { id: 'AIL.6', description: 'Start Date/Time', subfields: 'TS' },
  { id: 'AIL.7', description: 'Start Date/Time Offset', subfields: 'NM' },
  { id: 'AIL.8', description: 'Start Date/Time Offset Units', subfields: 'CE' },
  { id: 'AIL.9', description: 'Duration', subfields: 'NM' },
  { id: 'AIL.10', description: 'Duration Units', subfields: 'CE' },
  { id: 'AIL.11', description: 'Allow Substitution Code', subfields: 'IS' },
  { id: 'AIL.12', description: 'Filler Status Code', subfields: 'CE' },
  { id: 'AIP.1', description: 'Set ID - AIP', subfields: 'SI' },
  { id: 'AIP.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'AIP.3', description: 'Personnel Resource ID', subfields: 'XCN' },
  { id: 'AIP.4', description: 'Resource Type', subfields: 'CE' },
  { id: 'AIP.5', description: 'Resource Group', subfields: 'CE' },
  { id: 'AIP.6', description: 'Start Date/Time', subfields: 'TS' },
  { id: 'AIP.7', description: 'Start Date/Time Offset', subfields: 'NM' },
  { id: 'AIP.8', description: 'Start Date/Time Offset Units', subfields: 'CE' },
  { id: 'AIP.9', description: 'Duration', subfields: 'NM' },
  { id: 'AIP.10', description: 'Duration Units', subfields: 'CE' },
  { id: 'AIP.11', description: 'Allow Substitution Code', subfields: 'IS' },
  { id: 'AIP.12', description: 'Filler Status Code', subfields: 'CE' },
  { id: 'AIS.1', description: 'Set ID - AIS', subfields: 'SI' },
  { id: 'AIS.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'AIS.3', description: 'Universal Service Identifier', subfields: 'CE' },
  { id: 'AIS.4', description: 'Start Date/Time', subfields: 'TS' },
  { id: 'AIS.5', description: 'Start Date/Time Offset', subfields: 'NM' },
  { id: 'AIS.6', description: 'Start Date/Time Offset Units', subfields: 'CE' },
  { id: 'AIS.7', description: 'Duration', subfields: 'NM' },
  { id: 'AIS.8', description: 'Duration Units', subfields: 'CE' },
  { id: 'AIS.9', description: 'Allow Substitution Code', subfields: 'IS' },
  { id: 'AIS.10', description: 'Filler Status Code', subfields: 'CE' },
  {
    id: 'AIS.11',
    description: 'Placer Supplemental Service Information',
    subfields: 'CE',
  },
  {
    id: 'AIS.12',
    description: 'Filler Supplemental Service Information',
    subfields: 'CE',
  },
  { id: 'AL1.1', description: 'Set ID - AL1', subfields: 'SI' },
  { id: 'AL1.2', description: 'Allergen Type Code', subfields: 'CE' },
  {
    id: 'AL1.3',
    description: 'Allergen Code/Mnemonic/Description',
    subfields: 'CE',
  },
  { id: 'AL1.4', description: 'Allergy Severity Code', subfields: 'CE' },
  { id: 'AL1.5', description: 'Allergy Reaction Code', subfields: 'ST' },
  { id: 'AL1.6', description: 'Identification Date', subfields: 'DT' },
  { id: 'APR.1', description: 'Time Selection Criteria', subfields: 'SCV' },
  { id: 'APR.2', description: 'Resource Selection Criteria', subfields: 'SCV' },
  { id: 'APR.3', description: 'Location Selection Criteria', subfields: 'SCV' },
  { id: 'APR.4', description: 'Slot Spacing Criteria', subfields: 'NM' },
  { id: 'APR.5', description: 'Filler Override Criteria', subfields: 'SCV' },
  { id: 'ARQ.1', description: 'Placer Appointment ID', subfields: 'EI' },
  { id: 'ARQ.2', description: 'Filler Appointment ID', subfields: 'EI' },
  { id: 'ARQ.3', description: 'Occurrence Number', subfields: 'NM' },
  { id: 'ARQ.4', description: 'Placer Group Number', subfields: 'EI' },
  { id: 'ARQ.5', description: 'Schedule ID', subfields: 'CE' },
  { id: 'ARQ.6', description: 'Request Event Reason', subfields: 'CE' },
  { id: 'ARQ.7', description: 'Appointment Reason', subfields: 'CE' },
  { id: 'ARQ.8', description: 'Appointment Type', subfields: 'CE' },
  { id: 'ARQ.9', description: 'Appointment Duration', subfields: 'NM' },
  { id: 'ARQ.10', description: 'Appointment Duration Units', subfields: 'CE' },
  {
    id: 'ARQ.11',
    description: 'Requested Start Date/Time Range',
    subfields: 'DR',
  },
  { id: 'ARQ.12', description: 'Priority-ARQ', subfields: 'ST' },
  { id: 'ARQ.13', description: 'Repeating Interval', subfields: 'RI' },
  { id: 'ARQ.14', description: 'Repeating Interval Duration', subfields: 'ST' },
  { id: 'ARQ.15', description: 'Placer Contact Person', subfields: 'XCN' },
  {
    id: 'ARQ.16',
    description: 'Placer Contact Phone Number',
    subfields: 'XTN',
  },
  { id: 'ARQ.17', description: 'Placer Contact Address', subfields: 'XAD' },
  { id: 'ARQ.18', description: 'Placer Contact Location', subfields: 'PL' },
  { id: 'ARQ.19', description: 'Entered By Person', subfields: 'XCN' },
  { id: 'ARQ.20', description: 'Entered By Phone Number', subfields: 'XTN' },
  { id: 'ARQ.21', description: 'Entered By Location', subfields: 'PL' },
  {
    id: 'ARQ.22',
    description: 'Parent Placer Appointment ID',
    subfields: 'EI',
  },
  {
    id: 'ARQ.23',
    description: 'Parent Filler Appointment ID',
    subfields: 'EI',
  },
  { id: 'ARQ.24', description: 'Placer Order Number', subfields: 'EI' },
  { id: 'ARQ.25', description: 'Filler Order Number', subfields: 'EI' },
  { id: 'AUT.1', description: 'Authorizing Payor, Plan ID', subfields: 'CE' },
  {
    id: 'AUT.2',
    description: 'Authorizing Payor, Company ID',
    subfields: 'CE',
  },
  {
    id: 'AUT.3',
    description: 'Authorizing Payor, Company Name',
    subfields: 'ST',
  },
  { id: 'AUT.4', description: 'Authorization Effective Date', subfields: 'TS' },
  {
    id: 'AUT.5',
    description: 'Authorization Expiration Date',
    subfields: 'TS',
  },
  { id: 'AUT.6', description: 'Authorization Identifier', subfields: 'EI' },
  { id: 'AUT.7', description: 'Reimbursement Limit', subfields: 'CP' },
  {
    id: 'AUT.8',
    description: 'Requested Number of Treatments',
    subfields: 'NM',
  },
  {
    id: 'AUT.9',
    description: 'Authorized Number of Treatments',
    subfields: 'NM',
  },
  { id: 'AUT.10', description: 'Process Date', subfields: 'TS' },
  { id: 'BHS.1', description: 'Batch Field Separator', subfields: 'ST' },
  { id: 'BHS.2', description: 'Batch Encoding Characters', subfields: 'ST' },
  { id: 'BHS.3', description: 'Batch Sending Application', subfields: 'HD' },
  { id: 'BHS.4', description: 'Batch Sending Facility', subfields: 'HD' },
  { id: 'BHS.5', description: 'Batch Receiving Application', subfields: 'HD' },
  { id: 'BHS.6', description: 'Batch Receiving Facility', subfields: 'HD' },
  { id: 'BHS.7', description: 'Batch Creation Date/Time', subfields: 'TS' },
  { id: 'BHS.8', description: 'Batch Security', subfields: 'ST' },
  { id: 'BHS.9', description: 'Batch Name/ID/Type', subfields: 'ST' },
  { id: 'BHS.10', description: 'Batch Comment', subfields: 'ST' },
  { id: 'BHS.11', description: 'Batch Control ID', subfields: 'ST' },
  { id: 'BHS.12', description: 'Reference Batch Control ID', subfields: 'ST' },
  { id: 'BLC.1', description: 'Blood Product Code', subfields: 'CE' },
  { id: 'BLC.2', description: 'Blood Amount', subfields: 'CQ' },
  { id: 'BLG.1', description: 'When to Charge', subfields: 'CCD' },
  { id: 'BLG.2', description: 'Charge Type', subfields: 'ID' },
  { id: 'BLG.3', description: 'Account ID', subfields: 'CX' },
  { id: 'BLG.4', description: 'Charge Type Reason', subfields: 'CWE' },
  { id: 'BPO.1', description: 'Set ID - BPO', subfields: 'SI' },
  { id: 'BPO.2', description: 'BP Universal Service ID', subfields: 'CWE' },
  { id: 'BPO.3', description: 'BP  Processing Requirements', subfields: 'CWE' },
  { id: 'BPO.4', description: 'BP Quantity', subfields: 'NM' },
  { id: 'BPO.5', description: 'BP Amount', subfields: 'NM' },
  { id: 'BPO.6', description: 'BP Units', subfields: 'CE' },
  { id: 'BPO.7', description: 'BP Intended Use Date/Time', subfields: 'TS' },
  {
    id: 'BPO.8',
    description: 'BP Intended Dispense From Location',
    subfields: 'PL',
  },
  {
    id: 'BPO.9',
    description: 'BP Intended Dispense From Address',
    subfields: 'XAD',
  },
  {
    id: 'BPO.10',
    description: 'BP Requested Dispense Date/Time',
    subfields: 'TS',
  },
  {
    id: 'BPO.11',
    description: 'BP Requested Dispense To Location',
    subfields: 'PL',
  },
  {
    id: 'BPO.12',
    description: 'BP Requested Dispense To Address',
    subfields: 'XAD',
  },
  { id: 'BPO.13', description: 'BP Indication for Use', subfields: 'CWE' },
  {
    id: 'BPO.14',
    description: 'BP Informed Consent Indicator',
    subfields: 'ID',
  },
  { id: 'BPX.1', description: 'Set ID - BPX', subfields: 'SI' },
  { id: 'BPX.2', description: 'BP Dispense Status', subfields: 'CWE' },
  { id: 'BPX.3', description: 'BP Status', subfields: 'ID' },
  { id: 'BPX.4', description: 'BP Date/Time of Status', subfields: 'TS' },
  { id: 'BPX.5', description: 'BC Donation ID', subfields: 'EI' },
  { id: 'BPX.6', description: 'BC Component', subfields: 'CNE' },
  {
    id: 'BPX.7',
    description: 'BC Donation Type / Intended Use',
    subfields: 'CNE',
  },
  { id: 'BPX.8', description: 'CP Commercial Product', subfields: 'CWE' },
  { id: 'BPX.9', description: 'CP Manufacturer', subfields: 'XON' },
  { id: 'BPX.10', description: 'CP Lot Number', subfields: 'EI' },
  { id: 'BPX.11', description: 'BP Blood Group', subfields: 'CNE' },
  { id: 'BPX.12', description: 'BC Special Testing', subfields: 'CNE' },
  { id: 'BPX.13', description: 'BP Expiration Date/Time', subfields: 'TS' },
  { id: 'BPX.14', description: 'BP Quantity', subfields: 'NM' },
  { id: 'BPX.15', description: 'BP Amount', subfields: 'NM' },
  { id: 'BPX.16', description: 'BP Units', subfields: 'CE' },
  { id: 'BPX.17', description: 'BP Unique ID', subfields: 'EI' },
  {
    id: 'BPX.18',
    description: 'BP Actual Dispensed To Location',
    subfields: 'PL',
  },
  {
    id: 'BPX.19',
    description: 'BP Actual Dispensed To Address',
    subfields: 'XAD',
  },
  { id: 'BPX.20', description: 'BP Dispensed to Receiver', subfields: 'XCN' },
  { id: 'BPX.21', description: 'BP Dispensing Individual', subfields: 'XCN' },
  { id: 'BTS.1', description: 'Batch Message Count', subfields: 'ST' },
  { id: 'BTS.2', description: 'Batch Comment', subfields: 'ST' },
  { id: 'BTS.3', description: 'Batch Totals', subfields: 'NM' },
  { id: 'BTX.1', description: 'Set ID - BTX', subfields: 'SI' },
  { id: 'BTX.2', description: 'BC Donation ID', subfields: 'EI' },
  { id: 'BTX.3', description: 'BC Component', subfields: 'CNE' },
  { id: 'BTX.4', description: 'BC Blood Group', subfields: 'CNE' },
  { id: 'BTX.5', description: 'CP Commercial Product', subfields: 'CWE' },
  { id: 'BTX.6', description: 'CP Manufacturer', subfields: 'XON' },
  { id: 'BTX.7', description: 'CP Lot Number', subfields: 'EI' },
  { id: 'BTX.8', description: 'BP Quantity', subfields: 'NM' },
  { id: 'BTX.9', description: 'BP Amount', subfields: 'NM' },
  { id: 'BTX.10', description: 'BP Units', subfields: 'CE' },
  {
    id: 'BTX.11',
    description: 'BP Transfusion/Disposition Status',
    subfields: 'CWE',
  },
  { id: 'BTX.12', description: 'BP Message Status', subfields: 'ID' },
  { id: 'BTX.13', description: 'BP Date/Time of Status', subfields: 'TS' },
  { id: 'BTX.14', description: 'BP Administrator', subfields: 'XCN' },
  { id: 'BTX.15', description: 'BP Verifier', subfields: 'XCN' },
  {
    id: 'BTX.16',
    description: 'BP Transfusion Start Date/Time of Status',
    subfields: 'TS',
  },
  {
    id: 'BTX.17',
    description: 'BP Transfusion End Date/Time of Status',
    subfields: 'TS',
  },
  { id: 'BTX.18', description: 'BP Adverse Reaction Type', subfields: 'CWE' },
  {
    id: 'BTX.19',
    description: 'BP Transfusion Interrupted Reason',
    subfields: 'CWE',
  },
  { id: 'CDM.1', description: 'Primary Key Value - CDM', subfields: 'CE' },
  { id: 'CDM.2', description: 'Charge Code Alias', subfields: 'CE' },
  { id: 'CDM.3', description: 'Charge Description Short', subfields: 'ST' },
  { id: 'CDM.4', description: 'Charge Description Long', subfields: 'ST' },
  {
    id: 'CDM.5',
    description: 'Description Override Indicator',
    subfields: 'IS',
  },
  { id: 'CDM.6', description: 'Exploding Charges', subfields: 'CE' },
  { id: 'CDM.7', description: 'Procedure Code', subfields: 'CE' },
  { id: 'CDM.8', description: 'Active/Inactive Flag', subfields: 'ID' },
  { id: 'CDM.9', description: 'Inventory Number', subfields: 'CE' },
  { id: 'CDM.10', description: 'Resource Load', subfields: 'NM' },
  { id: 'CDM.11', description: 'Contract Number', subfields: 'CX' },
  { id: 'CDM.12', description: 'Contract Organization', subfields: 'XON' },
  { id: 'CDM.13', description: 'Room Fee Indicator', subfields: 'ID' },
  { id: 'CER.1', description: 'Set ID - CER', subfields: 'SI' },
  { id: 'CER.2', description: 'Serial Number', subfields: 'ST' },
  { id: 'CER.3', description: 'Version', subfields: 'ST' },
  { id: 'CER.4', description: 'Granting Authority', subfields: 'XON' },
  { id: 'CER.5', description: 'Issuing Authority', subfields: 'XCN' },
  {
    id: 'CER.6',
    description: 'Signature of Issuing Authority',
    subfields: 'ED',
  },
  { id: 'CER.7', description: 'Granting Country', subfields: 'ID' },
  { id: 'CER.8', description: 'Granting State/Province', subfields: 'CWE' },
  { id: 'CER.9', description: 'Granting County/Parish', subfields: 'CWE' },
  { id: 'CER.10', description: 'Certificate Type', subfields: 'CWE' },
  { id: 'CER.11', description: 'Certificate Domain', subfields: 'CWE' },
  { id: 'CER.12', description: 'Subject ID', subfields: 'ID' },
  { id: 'CER.13', description: 'Subject Name', subfields: 'ST' },
  {
    id: 'CER.14',
    description:
      'Subject Directory Attribute Extension (Health Professional Data)',
    subfields: 'CWE',
  },
  { id: 'CER.15', description: 'Subject Public Key Info', subfields: 'CWE' },
  { id: 'CER.16', description: 'Authority Key Identifier', subfields: 'CWE' },
  { id: 'CER.17', description: 'Basic Constraint', subfields: 'ID' },
  { id: 'CER.18', description: 'CRL Distribution Point', subfields: 'CWE' },
  { id: 'CER.19', description: 'Jurisdiction Country', subfields: 'ID' },
  {
    id: 'CER.20',
    description: 'Jurisdiction State/Province',
    subfields: 'CWE',
  },
  { id: 'CER.21', description: 'Jurisdiction County/Parish', subfields: 'CWE' },
  { id: 'CER.22', description: 'Jurisdiction Breadth', subfields: 'CWE' },
  { id: 'CER.23', description: 'Granting Date', subfields: 'TS' },
  { id: 'CER.24', description: 'Issuing Date', subfields: 'TS' },
  { id: 'CER.25', description: 'Activation Date', subfields: 'TS' },
  { id: 'CER.26', description: 'Inactivation Date', subfields: 'TS' },
  { id: 'CER.27', description: 'Expiration Date', subfields: 'TS' },
  { id: 'CER.28', description: 'Renewal Date', subfields: 'TS' },
  { id: 'CER.29', description: 'Revocation Date', subfields: 'TS' },
  { id: 'CER.30', description: 'Revocation Reason Code', subfields: 'CE' },
  { id: 'CER.31', description: 'Certificate Status', subfields: 'CWE' },
  { id: 'CM0.1', description: 'Set ID - CM0', subfields: 'SI' },
  { id: 'CM0.2', description: 'Sponsor Study ID', subfields: 'EI' },
  { id: 'CM0.3', description: 'Alternate Study ID', subfields: 'EI' },
  { id: 'CM0.4', description: 'Title of Study', subfields: 'ST' },
  { id: 'CM0.5', description: 'Chairman of Study', subfields: 'XCN' },
  { id: 'CM0.6', description: 'Last IRB Approval Date', subfields: 'DT' },
  { id: 'CM0.7', description: 'Total Accrual to Date', subfields: 'NM' },
  { id: 'CM0.8', description: 'Last Accrual Date', subfields: 'DT' },
  { id: 'CM0.9', description: 'Contact for Study', subfields: 'XCN' },
  { id: 'CM0.10', description: "Contact's Telephone Number", subfields: 'XTN' },
  { id: 'CM0.11', description: "Contact's Address", subfields: 'XAD' },
  { id: 'CM1.1', description: 'Set ID - CM1', subfields: 'SI' },
  { id: 'CM1.2', description: 'Study Phase Identifier', subfields: 'CE' },
  { id: 'CM1.3', description: 'Description of Study Phase', subfields: 'ST' },
  { id: 'CM2.1', description: 'Set ID - CM2', subfields: 'SI' },
  { id: 'CM2.2', description: 'Scheduled Time Point', subfields: 'CE' },
  { id: 'CM2.3', description: 'Description of Time Point', subfields: 'ST' },
  {
    id: 'CM2.4',
    description: 'Events Scheduled This Time Point',
    subfields: 'CE',
  },
  {
    id: 'CNS.1',
    description: 'Starting Notification Reference Number',
    subfields: 'NM',
  },
  {
    id: 'CNS.2',
    description: 'Ending Notification Reference Number',
    subfields: 'NM',
  },
  {
    id: 'CNS.3',
    description: 'Starting Notification Date/Time',
    subfields: 'TS',
  },
  {
    id: 'CNS.4',
    description: 'Ending Notification Date/Time',
    subfields: 'TS',
  },
  { id: 'CNS.5', description: 'Starting Notification Code', subfields: 'CE' },
  { id: 'CNS.6', description: 'Ending Notification Code', subfields: 'CE' },
  { id: 'CON.1', description: 'Set ID - CON', subfields: 'SI' },
  { id: 'CON.2', description: 'Consent Type', subfields: 'CWE' },
  { id: 'CON.3', description: 'Consent Form ID', subfields: 'ST' },
  { id: 'CON.4', description: 'Consent Form Number', subfields: 'EI' },
  { id: 'CON.5', description: 'Consent Text', subfields: 'FT' },
  {
    id: 'CON.6',
    description: 'Subject-specific Consent Text',
    subfields: 'FT',
  },
  { id: 'CON.7', description: 'Consent Background', subfields: 'FT' },
  {
    id: 'CON.8',
    description: 'Subject-specific Consent Background',
    subfields: 'FT',
  },
  {
    id: 'CON.9',
    description: 'Consenter-imposed limitations',
    subfields: 'FT',
  },
  { id: 'CON.10', description: 'Consent Mode', subfields: 'CNE' },
  { id: 'CON.11', description: 'Consent Status', subfields: 'CNE' },
  {
    id: 'CON.12',
    description: 'Consent Discussion Date/Time',
    subfields: 'TS',
  },
  { id: 'CON.13', description: 'Consent Decision Date/Time', subfields: 'TS' },
  { id: 'CON.14', description: 'Consent Effective Date/Time', subfields: 'TS' },
  { id: 'CON.15', description: 'Consent End Date/Time', subfields: 'TS' },
  {
    id: 'CON.16',
    description: 'Subject Competence Indicator',
    subfields: 'ID',
  },
  {
    id: 'CON.17',
    description: 'Translator Assistance Indicator',
    subfields: 'ID',
  },
  { id: 'CON.18', description: 'Language Translated To', subfields: 'ID' },
  {
    id: 'CON.19',
    description: 'Informational Material Supplied Indicator',
    subfields: 'ID',
  },
  { id: 'CON.20', description: 'Consent Bypass Reason', subfields: 'CWE' },
  { id: 'CON.21', description: 'Consent Disclosure Level', subfields: 'ID' },
  {
    id: 'CON.22',
    description: 'Consent Non-disclosure Reason',
    subfields: 'CWE',
  },
  {
    id: 'CON.23',
    description: 'Non-subject Consenter Reason',
    subfields: 'CWE',
  },
  { id: 'CON.24', description: 'Consenter ID', subfields: 'XPN' },
  {
    id: 'CON.25',
    description: 'Relationship to Subject Table',
    subfields: 'IS',
  },
  { id: 'CSP.1', description: 'Study Phase Identifier', subfields: 'CE' },
  { id: 'CSP.2', description: 'Date/time Study Phase Began', subfields: 'TS' },
  { id: 'CSP.3', description: 'Date/time Study Phase Ended', subfields: 'TS' },
  { id: 'CSP.4', description: 'Study Phase Evaluability', subfields: 'CE' },
  { id: 'CSR.1', description: 'Sponsor Study ID', subfields: 'EI' },
  { id: 'CSR.2', description: 'Alternate Study ID', subfields: 'EI' },
  {
    id: 'CSR.3',
    description: 'Institution Registering the Patient',
    subfields: 'CE',
  },
  { id: 'CSR.4', description: 'Sponsor Patient ID', subfields: 'CX' },
  { id: 'CSR.5', description: 'Alternate Patient ID - CSR', subfields: 'CX' },
  {
    id: 'CSR.6',
    description: 'Date/Time Of Patient Study Registration',
    subfields: 'TS',
  },
  {
    id: 'CSR.7',
    description: 'Person Performing Study Registration',
    subfields: 'XCN',
  },
  { id: 'CSR.8', description: 'Study Authorizing Provider', subfields: 'XCN' },
  {
    id: 'CSR.9',
    description: 'Date/time Patient Study Consent Signed',
    subfields: 'TS',
  },
  {
    id: 'CSR.10',
    description: 'Patient Study Eligibility Status',
    subfields: 'CE',
  },
  {
    id: 'CSR.11',
    description: 'Study Randomization Date/time',
    subfields: 'TS',
  },
  { id: 'CSR.12', description: 'Randomized Study Arm', subfields: 'CE' },
  {
    id: 'CSR.13',
    description: 'Stratum for Study Randomization',
    subfields: 'CE',
  },
  { id: 'CSR.14', description: 'Patient Evaluability Status', subfields: 'CE' },
  { id: 'CSR.15', description: 'Date/time Ended Study', subfields: 'TS' },
  { id: 'CSR.16', description: 'Reason Ended Study', subfields: 'CE' },
  { id: 'CSS.1', description: 'Study Scheduled Time Point', subfields: 'CE' },
  {
    id: 'CSS.2',
    description: 'Study Scheduled Patient Time Point',
    subfields: 'TS',
  },
  { id: 'CSS.3', description: 'Study Quality Control Codes', subfields: 'CE' },
  { id: 'CTD.1', description: 'Contact Role', subfields: 'CE' },
  { id: 'CTD.2', description: 'Contact Name', subfields: 'XPN' },
  { id: 'CTD.3', description: 'Contact Address', subfields: 'XAD' },
  { id: 'CTD.4', description: 'Contact Location', subfields: 'PL' },
  {
    id: 'CTD.5',
    description: 'Contact Communication Information',
    subfields: 'XTN',
  },
  { id: 'CTD.6', description: 'Preferred Method of Contact', subfields: 'CE' },
  { id: 'CTD.7', description: 'Contact Identifiers', subfields: 'PLN' },
  { id: 'CTI.1', description: 'Sponsor Study ID', subfields: 'EI' },
  { id: 'CTI.2', description: 'Study Phase Identifier', subfields: 'CE' },
  { id: 'CTI.3', description: 'Study Scheduled Time Point', subfields: 'CE' },
  { id: 'DB1.1', description: 'Set ID - DB1', subfields: 'SI' },
  { id: 'DB1.2', description: 'Disabled Person Code', subfields: 'IS' },
  { id: 'DB1.3', description: 'Disabled Person Identifier', subfields: 'CX' },
  { id: 'DB1.4', description: 'Disabled Indicator', subfields: 'ID' },
  { id: 'DB1.5', description: 'Disability Start Date', subfields: 'DT' },
  { id: 'DB1.6', description: 'Disability End Date', subfields: 'DT' },
  {
    id: 'DB1.7',
    description: 'Disability Return to Work Date',
    subfields: 'DT',
  },
  {
    id: 'DB1.8',
    description: 'Disability Unable to Work Date',
    subfields: 'DT',
  },
  { id: 'DG1.1', description: 'Set ID - DG1', subfields: 'SI' },
  { id: 'DG1.2', description: 'Diagnosis Coding Method', subfields: 'ID' },
  { id: 'DG1.3', description: 'Diagnosis Code - DG1', subfields: 'CE' },
  { id: 'DG1.4', description: 'Diagnosis Description', subfields: 'ST' },
  { id: 'DG1.5', description: 'Diagnosis Date/Time', subfields: 'TS' },
  { id: 'DG1.6', description: 'Diagnosis Type', subfields: 'IS' },
  { id: 'DG1.7', description: 'Major Diagnostic Category', subfields: 'CE' },
  { id: 'DG1.8', description: 'Diagnostic Related Group', subfields: 'CE' },
  { id: 'DG1.9', description: 'DRG Approval Indicator', subfields: 'ID' },
  { id: 'DG1.10', description: 'DRG Grouper Review Code', subfields: 'IS' },
  { id: 'DG1.11', description: 'Outlier Type', subfields: 'CE' },
  { id: 'DG1.12', description: 'Outlier Days', subfields: 'NM' },
  { id: 'DG1.13', description: 'Outlier Cost', subfields: 'CP' },
  { id: 'DG1.14', description: 'Grouper Version And Type', subfields: 'ST' },
  { id: 'DG1.15', description: 'Diagnosis Priority', subfields: 'ID' },
  { id: 'DG1.16', description: 'Diagnosing Clinician', subfields: 'XCN' },
  { id: 'DG1.17', description: 'Diagnosis Classification', subfields: 'IS' },
  { id: 'DG1.18', description: 'Confidential Indicator', subfields: 'ID' },
  { id: 'DG1.19', description: 'Attestation Date/Time', subfields: 'TS' },
  { id: 'DG1.20', description: 'Diagnosis Identifier', subfields: 'EI' },
  { id: 'DG1.21', description: 'Diagnosis Action Code', subfields: 'ID' },
  { id: 'DRG.1', description: 'Diagnostic Related Group', subfields: 'CE' },
  { id: 'DRG.2', description: 'DRG Assigned Date/Time', subfields: 'TS' },
  { id: 'DRG.3', description: 'DRG Approval Indicator', subfields: 'ID' },
  { id: 'DRG.4', description: 'DRG Grouper Review Code', subfields: 'IS' },
  { id: 'DRG.5', description: 'Outlier Type', subfields: 'CE' },
  { id: 'DRG.6', description: 'Outlier Days', subfields: 'NM' },
  { id: 'DRG.7', description: 'Outlier Cost', subfields: 'CP' },
  { id: 'DRG.8', description: 'DRG Payor', subfields: 'IS' },
  { id: 'DRG.9', description: 'Outlier Reimbursement', subfields: 'CP' },
  { id: 'DRG.10', description: 'Confidential Indicator', subfields: 'ID' },
  { id: 'DRG.11', description: 'DRG Transfer Type', subfields: 'IS' },
  { id: 'DSC.1', description: 'Continuation Pointer', subfields: 'ST' },
  { id: 'DSC.2', description: 'Continuation Style', subfields: 'ID' },
  { id: 'DSP.1', description: 'Set ID - DSP', subfields: 'SI' },
  { id: 'DSP.2', description: 'Display Level', subfields: 'SI' },
  { id: 'DSP.3', description: 'Data Line', subfields: 'TX' },
  { id: 'DSP.4', description: 'Logical Break Point', subfields: 'ST' },
  { id: 'DSP.5', description: 'Result ID', subfields: 'TX' },
  { id: 'ECD.1', description: 'Reference Command Number', subfields: 'NM' },
  { id: 'ECD.2', description: 'Remote Control Command', subfields: 'CE' },
  { id: 'ECD.3', description: 'Response Required', subfields: 'ID' },
  { id: 'ECD.4', description: 'Requested Completion Time', subfields: 'TQ' },
  { id: 'ECD.5', description: 'Parameters', subfields: 'TX' },
  { id: 'ECR.1', description: 'Command Response', subfields: 'CE' },
  { id: 'ECR.2', description: 'Date/Time Completed', subfields: 'TS' },
  { id: 'ECR.3', description: 'Command Response Parameters', subfields: 'TX' },
  { id: 'EDU.1', description: 'Set ID - EDU', subfields: 'SI' },
  { id: 'EDU.2', description: 'Academic Degree', subfields: 'IS' },
  {
    id: 'EDU.3',
    description: 'Academic Degree Program Date Range',
    subfields: 'DR',
  },
  {
    id: 'EDU.4',
    description: 'Academic Degree Program Participation Date Range',
    subfields: 'DR',
  },
  { id: 'EDU.5', description: 'Academic Degree Granted Date', subfields: 'DT' },
  { id: 'EDU.6', description: 'School', subfields: 'XON' },
  { id: 'EDU.7', description: 'School Type Code', subfields: 'CE' },
  { id: 'EDU.8', description: 'School Address', subfields: 'XAD' },
  { id: 'EDU.9', description: 'Major Field of Study', subfields: 'CWE' },
  { id: 'EQL.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'EQL.2', description: 'Query/Response Format Code', subfields: 'ID' },
  { id: 'EQL.3', description: 'EQL Query Name', subfields: 'CE' },
  { id: 'EQL.4', description: 'EQL Query Statement', subfields: 'ST' },
  { id: 'EQP.1', description: 'Event type', subfields: 'CE' },
  { id: 'EQP.2', description: 'File Name', subfields: 'ST' },
  { id: 'EQP.3', description: 'Start Date/Time', subfields: 'TS' },
  { id: 'EQP.4', description: 'End Date/Time', subfields: 'TS' },
  { id: 'EQP.5', description: 'Transaction Data', subfields: 'FT' },
  {
    id: 'EQU.1',
    description: 'Equipment Instance Identifier',
    subfields: 'EI',
  },
  { id: 'EQU.2', description: 'Event Date/Time', subfields: 'TS' },
  { id: 'EQU.3', description: 'Equipment State', subfields: 'CE' },
  { id: 'EQU.4', description: 'Local/Remote Control State', subfields: 'CE' },
  { id: 'EQU.5', description: 'Alert Level', subfields: 'CE' },
  { id: 'ERQ.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'ERQ.2', description: 'Event Identifier', subfields: 'CE' },
  { id: 'ERQ.3', description: 'Input Parameter List', subfields: 'QIP' },
  { id: 'ERR.1', description: 'Error Code and Location', subfields: 'ELD' },
  { id: 'ERR.2', description: 'Error Location', subfields: 'ERL' },
  { id: 'ERR.3', description: 'HL7 Error Code', subfields: 'CWE' },
  { id: 'ERR.4', description: 'Severity', subfields: 'ID' },
  { id: 'ERR.5', description: 'Application Error Code', subfields: 'CWE' },
  { id: 'ERR.6', description: 'Application Error Parameter', subfields: 'ST' },
  { id: 'ERR.7', description: 'Diagnostic Information', subfields: 'TX' },
  { id: 'ERR.8', description: 'User Message', subfields: 'TX' },
  { id: 'ERR.9', description: 'Inform Person Indicator', subfields: 'IS' },
  { id: 'ERR.10', description: 'Override Type', subfields: 'CWE' },
  { id: 'ERR.11', description: 'Override Reason Code', subfields: 'CWE' },
  { id: 'ERR.12', description: 'Help Desk Contact Point', subfields: 'XTN' },
  { id: 'EVN.1', description: 'Event Type Code', subfields: 'ID' },
  { id: 'EVN.2', description: 'Recorded Date/Time', subfields: 'TS' },
  { id: 'EVN.3', description: 'Date/Time Planned Event', subfields: 'TS' },
  { id: 'EVN.4', description: 'Event Reason Code', subfields: 'IS' },
  { id: 'EVN.5', description: 'Operator ID', subfields: 'XCN' },
  { id: 'EVN.6', description: 'Event Occurred', subfields: 'TS' },
  { id: 'EVN.7', description: 'Event Facility', subfields: 'HD' },
  { id: 'FAC.1', description: 'Facility ID-FAC', subfields: 'EI' },
  { id: 'FAC.2', description: 'Facility Type', subfields: 'ID' },
  { id: 'FAC.3', description: 'Facility Address', subfields: 'XAD' },
  { id: 'FAC.4', description: 'Facility Telecommunication', subfields: 'XTN' },
  { id: 'FAC.5', description: 'Contact Person', subfields: 'XCN' },
  { id: 'FAC.6', description: 'Contact Title', subfields: 'ST' },
  { id: 'FAC.7', description: 'Contact Address', subfields: 'XAD' },
  { id: 'FAC.8', description: 'Contact Telecommunication', subfields: 'XTN' },
  { id: 'FAC.9', description: 'Signature Authority', subfields: 'XCN' },
  { id: 'FAC.10', description: 'Signature Authority Title', subfields: 'ST' },
  {
    id: 'FAC.11',
    description: 'Signature Authority Address',
    subfields: 'XAD',
  },
  {
    id: 'FAC.12',
    description: 'Signature Authority Telecommunication',
    subfields: 'XTN',
  },
  { id: 'FHS.1', description: 'File Field Separator', subfields: 'ST' },
  { id: 'FHS.2', description: 'File Encoding Characters', subfields: 'ST' },
  { id: 'FHS.3', description: 'File Sending Application', subfields: 'HD' },
  { id: 'FHS.4', description: 'File Sending Facility', subfields: 'HD' },
  { id: 'FHS.5', description: 'File Receiving Application', subfields: 'HD' },
  { id: 'FHS.6', description: 'File Receiving Facility', subfields: 'HD' },
  { id: 'FHS.7', description: 'File Creation Date/Time', subfields: 'TS' },
  { id: 'FHS.8', description: 'File Security', subfields: 'ST' },
  { id: 'FHS.9', description: 'File Name/ID', subfields: 'ST' },
  { id: 'FHS.10', description: 'File Header Comment', subfields: 'ST' },
  { id: 'FHS.11', description: 'File Control ID', subfields: 'ST' },
  { id: 'FHS.12', description: 'Reference File Control ID', subfields: 'ST' },
  { id: 'FT1.1', description: 'Set ID - FT1', subfields: 'SI' },
  { id: 'FT1.2', description: 'Transaction ID', subfields: 'ST' },
  { id: 'FT1.3', description: 'Transaction Batch ID', subfields: 'ST' },
  { id: 'FT1.4', description: 'Transaction Date', subfields: 'DR' },
  { id: 'FT1.5', description: 'Transaction Posting Date', subfields: 'TS' },
  { id: 'FT1.6', description: 'Transaction Type', subfields: 'IS' },
  { id: 'FT1.7', description: 'Transaction Code', subfields: 'CE' },
  { id: 'FT1.8', description: 'Transaction Description', subfields: 'ST' },
  {
    id: 'FT1.9',
    description: 'Transaction Description - Alt',
    subfields: 'ST',
  },
  { id: 'FT1.10', description: 'Transaction Quantity', subfields: 'NM' },
  {
    id: 'FT1.11',
    description: 'Transaction Amount - Extended',
    subfields: 'CP',
  },
  { id: 'FT1.12', description: 'Transaction Amount - Unit', subfields: 'CP' },
  { id: 'FT1.13', description: 'Department Code', subfields: 'CE' },
  { id: 'FT1.14', description: 'Insurance Plan ID', subfields: 'CE' },
  { id: 'FT1.15', description: 'Insurance Amount', subfields: 'CP' },
  { id: 'FT1.16', description: 'Assigned Patient Location', subfields: 'PL' },
  { id: 'FT1.17', description: 'Fee Schedule', subfields: 'IS' },
  { id: 'FT1.18', description: 'Patient Type', subfields: 'IS' },
  { id: 'FT1.19', description: 'Diagnosis Code - FT1', subfields: 'CE' },
  { id: 'FT1.20', description: 'Performed By Code', subfields: 'XCN' },
  { id: 'FT1.21', description: 'Ordered By Code', subfields: 'XCN' },
  { id: 'FT1.22', description: 'Unit Cost', subfields: 'CP' },
  { id: 'FT1.23', description: 'Filler Order Number', subfields: 'EI' },
  { id: 'FT1.24', description: 'Entered By Code', subfields: 'XCN' },
  { id: 'FT1.25', description: 'Procedure Code', subfields: 'CE' },
  { id: 'FT1.26', description: 'Procedure Code Modifier', subfields: 'CE' },
  {
    id: 'FT1.27',
    description: 'Advanced Beneficiary Notice Code',
    subfields: 'CE',
  },
  {
    id: 'FT1.28',
    description: 'Medically Necessary Duplicate Procedure Reason.',
    subfields: 'CWE',
  },
  { id: 'FT1.29', description: 'NDC Code', subfields: 'CNE' },
  { id: 'FT1.30', description: 'Payment Reference ID', subfields: 'CX' },
  { id: 'FT1.31', description: 'Transaction Reference Key', subfields: 'SI' },
  { id: 'FTS.1', description: 'File Batch Count', subfields: 'NM' },
  { id: 'FTS.2', description: 'File Trailer Comment', subfields: 'ST' },
  { id: 'GOL.1', description: 'Action Code', subfields: 'ID' },
  { id: 'GOL.2', description: 'Action Date/Time', subfields: 'TS' },
  { id: 'GOL.3', description: 'Goal ID', subfields: 'CE' },
  { id: 'GOL.4', description: 'Goal Instance ID', subfields: 'EI' },
  { id: 'GOL.5', description: 'Episode of Care ID', subfields: 'EI' },
  { id: 'GOL.6', description: 'Goal List Priority', subfields: 'NM' },
  { id: 'GOL.7', description: 'Goal Established Date/Time', subfields: 'TS' },
  {
    id: 'GOL.8',
    description: 'Expected Goal Achieve Date/Time',
    subfields: 'TS',
  },
  { id: 'GOL.9', description: 'Goal Classification', subfields: 'CE' },
  { id: 'GOL.10', description: 'Goal Management Discipline', subfields: 'CE' },
  { id: 'GOL.11', description: 'Current Goal Review Status', subfields: 'CE' },
  {
    id: 'GOL.12',
    description: 'Current Goal Review Date/Time',
    subfields: 'TS',
  },
  { id: 'GOL.13', description: 'Next Goal Review Date/Time', subfields: 'TS' },
  {
    id: 'GOL.14',
    description: 'Previous Goal Review Date/Time',
    subfields: 'TS',
  },
  { id: 'GOL.15', description: 'Goal Review Interval', subfields: 'TQ' },
  { id: 'GOL.16', description: 'Goal Evaluation', subfields: 'CE' },
  { id: 'GOL.17', description: 'Goal Evaluation Comment', subfields: 'ST' },
  { id: 'GOL.18', description: 'Goal Life Cycle Status', subfields: 'CE' },
  {
    id: 'GOL.19',
    description: 'Goal Life Cycle Status Date/Time',
    subfields: 'TS',
  },
  { id: 'GOL.20', description: 'Goal Target Type', subfields: 'CE' },
  { id: 'GOL.21', description: 'Goal Target Name', subfields: 'XPN' },
  { id: 'GP1.1', description: 'Type of Bill Code', subfields: 'IS' },
  { id: 'GP1.2', description: 'Revenue Code', subfields: 'IS' },
  {
    id: 'GP1.3',
    description: 'Overall Claim Disposition Code',
    subfields: 'IS',
  },
  { id: 'GP1.4', description: 'OCE Edits per Visit Code', subfields: 'IS' },
  { id: 'GP1.5', description: 'Outlier Cost', subfields: 'CP' },
  { id: 'GP2.1', description: 'Revenue Code', subfields: 'IS' },
  { id: 'GP2.2', description: 'Number of Service Units', subfields: 'NM' },
  { id: 'GP2.3', description: 'Charge', subfields: 'CP' },
  { id: 'GP2.4', description: 'Reimbursement Action Code', subfields: 'IS' },
  { id: 'GP2.5', description: 'Denial or Rejection Code', subfields: 'IS' },
  { id: 'GP2.6', description: 'OCE Edit Code', subfields: 'IS' },
  {
    id: 'GP2.7',
    description: 'Ambulatory Payment Classification Code',
    subfields: 'CE',
  },
  { id: 'GP2.8', description: 'Modifier Edit Code', subfields: 'IS' },
  { id: 'GP2.9', description: 'Payment Adjustment Code', subfields: 'IS' },
  { id: 'GP2.10', description: 'Packaging Status Code', subfields: 'IS' },
  { id: 'GP2.11', description: 'Expected CMS Payment Amount', subfields: 'CP' },
  { id: 'GP2.12', description: 'Reimbursement Type Code', subfields: 'IS' },
  { id: 'GP2.13', description: 'Co-Pay Amount', subfields: 'CP' },
  { id: 'GP2.14', description: 'Pay Rate per Service Unit', subfields: 'NM' },
  { id: 'GT1.1', description: 'Set ID - GT1', subfields: 'SI' },
  { id: 'GT1.2', description: 'Guarantor Number', subfields: 'CX' },
  { id: 'GT1.3', description: 'Guarantor Name', subfields: 'XPN' },
  { id: 'GT1.4', description: 'Guarantor Spouse Name', subfields: 'XPN' },
  { id: 'GT1.5', description: 'Guarantor Address', subfields: 'XAD' },
  { id: 'GT1.6', description: 'Guarantor Ph Num - Home', subfields: 'XTN' },
  { id: 'GT1.7', description: 'Guarantor Ph Num - Business', subfields: 'XTN' },
  { id: 'GT1.8', description: 'Guarantor Date/Time Of Birth', subfields: 'TS' },
  { id: 'GT1.9', description: 'Guarantor Administrative Sex', subfields: 'IS' },
  { id: 'GT1.10', description: 'Guarantor Type', subfields: 'IS' },
  { id: 'GT1.11', description: 'Guarantor Relationship', subfields: 'CE' },
  { id: 'GT1.12', description: 'Guarantor SSN', subfields: 'ST' },
  { id: 'GT1.13', description: 'Guarantor Date - Begin', subfields: 'DT' },
  { id: 'GT1.14', description: 'Guarantor Date - End', subfields: 'DT' },
  { id: 'GT1.15', description: 'Guarantor Priority', subfields: 'NM' },
  { id: 'GT1.16', description: 'Guarantor Employer Name', subfields: 'XPN' },
  { id: 'GT1.17', description: 'Guarantor Employer Address', subfields: 'XAD' },
  {
    id: 'GT1.18',
    description: 'Guarantor Employer Phone Number',
    subfields: 'XTN',
  },
  {
    id: 'GT1.19',
    description: 'Guarantor Employee ID Number',
    subfields: 'CX',
  },
  { id: 'GT1.20', description: 'Guarantor Employment Status', subfields: 'IS' },
  {
    id: 'GT1.21',
    description: 'Guarantor Organization Name',
    subfields: 'XON',
  },
  { id: 'GT1.22', description: 'Guarantor Billing Hold Flag', subfields: 'ID' },
  {
    id: 'GT1.23',
    description: 'Guarantor Credit Rating Code',
    subfields: 'CE',
  },
  {
    id: 'GT1.24',
    description: 'Guarantor Death Date And Time',
    subfields: 'TS',
  },
  { id: 'GT1.25', description: 'Guarantor Death Flag', subfields: 'ID' },
  {
    id: 'GT1.26',
    description: 'Guarantor Charge Adjustment Code',
    subfields: 'CE',
  },
  {
    id: 'GT1.27',
    description: 'Guarantor Household Annual Income',
    subfields: 'CP',
  },
  { id: 'GT1.28', description: 'Guarantor Household Size', subfields: 'NM' },
  {
    id: 'GT1.29',
    description: 'Guarantor Employer ID Number',
    subfields: 'CX',
  },
  {
    id: 'GT1.30',
    description: 'Guarantor Marital Status Code',
    subfields: 'CE',
  },
  {
    id: 'GT1.31',
    description: 'Guarantor Hire Effective Date',
    subfields: 'DT',
  },
  { id: 'GT1.32', description: 'Employment Stop Date', subfields: 'DT' },
  { id: 'GT1.33', description: 'Living Dependency', subfields: 'IS' },
  { id: 'GT1.34', description: 'Ambulatory Status', subfields: 'IS' },
  { id: 'GT1.35', description: 'Citizenship', subfields: 'CE' },
  { id: 'GT1.36', description: 'Primary Language', subfields: 'CE' },
  { id: 'GT1.37', description: 'Living Arrangement', subfields: 'IS' },
  { id: 'GT1.38', description: 'Publicity Code', subfields: 'CE' },
  { id: 'GT1.39', description: 'Protection Indicator', subfields: 'ID' },
  { id: 'GT1.40', description: 'Student Indicator', subfields: 'IS' },
  { id: 'GT1.41', description: 'Religion', subfields: 'CE' },
  { id: 'GT1.42', description: "Mother's Maiden Name", subfields: 'XPN' },
  { id: 'GT1.43', description: 'Nationality', subfields: 'CE' },
  { id: 'GT1.44', description: 'Ethnic Group', subfields: 'CE' },
  { id: 'GT1.45', description: "Contact Person's Name", subfields: 'XPN' },
  {
    id: 'GT1.46',
    description: "Contact Person's Telephone Number",
    subfields: 'XTN',
  },
  { id: 'GT1.47', description: 'Contact Reason', subfields: 'CE' },
  { id: 'GT1.48', description: 'Contact Relationship', subfields: 'IS' },
  { id: 'GT1.49', description: 'Job Title', subfields: 'ST' },
  { id: 'GT1.50', description: 'Job Code/Class', subfields: 'JCC' },
  {
    id: 'GT1.51',
    description: "Guarantor Employer's Organization Name",
    subfields: 'XON',
  },
  { id: 'GT1.52', description: 'Handicap', subfields: 'IS' },
  { id: 'GT1.53', description: 'Job Status', subfields: 'IS' },
  { id: 'GT1.54', description: 'Guarantor Financial Class', subfields: 'FC' },
  { id: 'GT1.55', description: 'Guarantor Race', subfields: 'CE' },
  { id: 'GT1.56', description: 'Guarantor Birth Place', subfields: 'ST' },
  { id: 'GT1.57', description: 'VIP Indicator', subfields: 'IS' },
  { id: 'IAM.1', description: 'Set ID - IAM', subfields: 'SI' },
  { id: 'IAM.2', description: 'Allergen Type Code', subfields: 'CE' },
  {
    id: 'IAM.3',
    description: 'Allergen Code/Mnemonic/Description',
    subfields: 'CE',
  },
  { id: 'IAM.4', description: 'Allergy Severity Code', subfields: 'CE' },
  { id: 'IAM.5', description: 'Allergy Reaction Code', subfields: 'ST' },
  { id: 'IAM.6', description: 'Allergy Action Code', subfields: 'CNE' },
  { id: 'IAM.7', description: 'Allergy Unique Identifier', subfields: 'EI' },
  { id: 'IAM.8', description: 'Action Reason', subfields: 'ST' },
  {
    id: 'IAM.9',
    description: 'Sensitivity to Causative Agent Code',
    subfields: 'CE',
  },
  {
    id: 'IAM.10',
    description: 'Allergen Group Code/Mnemonic/Description',
    subfields: 'CE',
  },
  { id: 'IAM.11', description: 'Onset Date', subfields: 'DT' },
  { id: 'IAM.12', description: 'Onset Date Text', subfields: 'ST' },
  { id: 'IAM.13', description: 'Reported Date/Time', subfields: 'TS' },
  { id: 'IAM.14', description: 'Reported By', subfields: 'XPN' },
  {
    id: 'IAM.15',
    description: 'Relationship to Patient Code',
    subfields: 'CE',
  },
  { id: 'IAM.16', description: 'Alert Device Code', subfields: 'CE' },
  {
    id: 'IAM.17',
    description: 'Allergy Clinical Status Code',
    subfields: 'CE',
  },
  { id: 'IAM.18', description: 'Statused by Person', subfields: 'XCN' },
  { id: 'IAM.19', description: 'Statused by Organization', subfields: 'XON' },
  { id: 'IAM.20', description: 'Statused at Date/Time', subfields: 'TS' },
  { id: 'IIM.1', description: 'Primary Key Value - IIM', subfields: 'CWE' },
  { id: 'IIM.2', description: 'Service Item Code', subfields: 'CWE' },
  { id: 'IIM.3', description: 'Inventory Lot Number', subfields: 'ST' },
  { id: 'IIM.4', description: 'Inventory Expiration Date', subfields: 'TS' },
  { id: 'IIM.5', description: 'Inventory Manufacturer Name', subfields: 'CWE' },
  { id: 'IIM.6', description: 'Inventory Location', subfields: 'CWE' },
  { id: 'IIM.7', description: 'Inventory Received Date', subfields: 'TS' },
  { id: 'IIM.8', description: 'Inventory Received Quantity', subfields: 'NM' },
  {
    id: 'IIM.9',
    description: 'Inventory Received Quantity Unit',
    subfields: 'CWE',
  },
  {
    id: 'IIM.10',
    description: 'Inventory Received Item Cost',
    subfields: 'MO',
  },
  { id: 'IIM.11', description: 'Inventory On Hand Date', subfields: 'TS' },
  { id: 'IIM.12', description: 'Inventory On Hand Quantity', subfields: 'NM' },
  {
    id: 'IIM.13',
    description: 'Inventory On Hand Quantity Unit',
    subfields: 'CWE',
  },
  { id: 'IIM.14', description: 'Procedure Code', subfields: 'CE' },
  { id: 'IIM.15', description: 'Procedure Code Modifier', subfields: 'CE' },
  { id: 'IN1.1', description: 'Set ID - IN1', subfields: 'SI' },
  { id: 'IN1.2', description: 'Insurance Plan ID', subfields: 'CE' },
  { id: 'IN1.3', description: 'Insurance Company ID', subfields: 'CX' },
  { id: 'IN1.4', description: 'Insurance Company Name', subfields: 'XON' },
  { id: 'IN1.5', description: 'Insurance Company Address', subfields: 'XAD' },
  { id: 'IN1.6', description: 'Insurance Co Contact Person', subfields: 'XPN' },
  { id: 'IN1.7', description: 'Insurance Co Phone Number', subfields: 'XTN' },
  { id: 'IN1.8', description: 'Group Number', subfields: 'ST' },
  { id: 'IN1.9', description: 'Group Name', subfields: 'XON' },
  { id: 'IN1.10', description: "Insured's Group Emp ID", subfields: 'CX' },
  { id: 'IN1.11', description: "Insured's Group Emp Name", subfields: 'XON' },
  { id: 'IN1.12', description: 'Plan Effective Date', subfields: 'DT' },
  { id: 'IN1.13', description: 'Plan Expiration Date', subfields: 'DT' },
  { id: 'IN1.14', description: 'Authorization Information', subfields: 'AUI' },
  { id: 'IN1.15', description: 'Plan Type', subfields: 'IS' },
  { id: 'IN1.16', description: 'Name Of Insured', subfields: 'XPN' },
  {
    id: 'IN1.17',
    description: "Insured's Relationship To Patient",
    subfields: 'CE',
  },
  { id: 'IN1.18', description: "Insured's Date Of Birth", subfields: 'TS' },
  { id: 'IN1.19', description: "Insured's Address", subfields: 'XAD' },
  { id: 'IN1.20', description: 'Assignment Of Benefits', subfields: 'IS' },
  { id: 'IN1.21', description: 'Coordination Of Benefits', subfields: 'IS' },
  { id: 'IN1.22', description: 'Coord Of Ben. Priority', subfields: 'ST' },
  { id: 'IN1.23', description: 'Notice Of Admission Flag', subfields: 'ID' },
  { id: 'IN1.24', description: 'Notice Of Admission Date', subfields: 'DT' },
  { id: 'IN1.25', description: 'Report Of Eligibility Flag', subfields: 'ID' },
  { id: 'IN1.26', description: 'Report Of Eligibility Date', subfields: 'DT' },
  { id: 'IN1.27', description: 'Release Information Code', subfields: 'IS' },
  { id: 'IN1.28', description: 'Pre-Admit Cert (PAC)', subfields: 'ST' },
  { id: 'IN1.29', description: 'Verification Date/Time', subfields: 'TS' },
  { id: 'IN1.30', description: 'Verification By', subfields: 'XCN' },
  { id: 'IN1.31', description: 'Type Of Agreement Code', subfields: 'IS' },
  { id: 'IN1.32', description: 'Billing Status', subfields: 'IS' },
  { id: 'IN1.33', description: 'Lifetime Reserve Days', subfields: 'NM' },
  { id: 'IN1.34', description: 'Delay Before L.R. Day', subfields: 'NM' },
  { id: 'IN1.35', description: 'Company Plan Code', subfields: 'IS' },
  { id: 'IN1.36', description: 'Policy Number', subfields: 'ST' },
  { id: 'IN1.37', description: 'Policy Deductible', subfields: 'CP' },
  { id: 'IN1.38', description: 'Policy Limit - Amount', subfields: 'CP' },
  { id: 'IN1.39', description: 'Policy Limit - Days', subfields: 'NM' },
  { id: 'IN1.40', description: 'Room Rate - Semi-Private', subfields: 'CP' },
  { id: 'IN1.41', description: 'Room Rate - Private', subfields: 'CP' },
  { id: 'IN1.42', description: "Insured's Employment Status", subfields: 'CE' },
  {
    id: 'IN1.43',
    description: "Insured's Administrative Sex",
    subfields: 'IS',
  },
  {
    id: 'IN1.44',
    description: "Insured's Employer's Address",
    subfields: 'XAD',
  },
  { id: 'IN1.45', description: 'Verification Status', subfields: 'ST' },
  { id: 'IN1.46', description: 'Prior Insurance Plan ID', subfields: 'IS' },
  { id: 'IN1.47', description: 'Coverage Type', subfields: 'IS' },
  { id: 'IN1.48', description: 'Handicap', subfields: 'IS' },
  { id: 'IN1.49', description: "Insured's ID Number", subfields: 'CX' },
  { id: 'IN1.50', description: 'Signature Code', subfields: 'IS' },
  { id: 'IN1.51', description: 'Signature Code Date', subfields: 'DT' },
  { id: 'IN1.52', description: "Insured's Birth Place", subfields: 'ST' },
  { id: 'IN1.53', description: 'VIP Indicator', subfields: 'IS' },
  { id: 'IN2.1', description: "Insured's Employee ID", subfields: 'CX' },
  {
    id: 'IN2.2',
    description: "Insured's Social Security Number",
    subfields: 'ST',
  },
  {
    id: 'IN2.3',
    description: "Insured's Employer's Name and ID",
    subfields: 'XCN',
  },
  { id: 'IN2.4', description: 'Employer Information Data', subfields: 'IS' },
  { id: 'IN2.5', description: 'Mail Claim Party', subfields: 'IS' },
  {
    id: 'IN2.6',
    description: 'Medicare Health Ins Card Number',
    subfields: 'ST',
  },
  { id: 'IN2.7', description: 'Medicaid Case Name', subfields: 'XPN' },
  { id: 'IN2.8', description: 'Medicaid Case Number', subfields: 'ST' },
  { id: 'IN2.9', description: 'Military Sponsor Name', subfields: 'XPN' },
  { id: 'IN2.10', description: 'Military ID Number', subfields: 'ST' },
  {
    id: 'IN2.11',
    description: 'Dependent Of Military Recipient',
    subfields: 'CE',
  },
  { id: 'IN2.12', description: 'Military Organization', subfields: 'ST' },
  { id: 'IN2.13', description: 'Military Station', subfields: 'ST' },
  { id: 'IN2.14', description: 'Military Service', subfields: 'IS' },
  { id: 'IN2.15', description: 'Military Rank/Grade', subfields: 'IS' },
  { id: 'IN2.16', description: 'Military Status', subfields: 'IS' },
  { id: 'IN2.17', description: 'Military Retire Date', subfields: 'DT' },
  {
    id: 'IN2.18',
    description: 'Military Non-Avail Cert On File',
    subfields: 'ID',
  },
  { id: 'IN2.19', description: 'Baby Coverage', subfields: 'ID' },
  { id: 'IN2.20', description: 'Combine Baby Bill', subfields: 'ID' },
  { id: 'IN2.21', description: 'Blood Deductible', subfields: 'ST' },
  {
    id: 'IN2.22',
    description: 'Special Coverage Approval Name',
    subfields: 'XPN',
  },
  {
    id: 'IN2.23',
    description: 'Special Coverage Approval Title',
    subfields: 'ST',
  },
  { id: 'IN2.24', description: 'Non-Covered Insurance Code', subfields: 'IS' },
  { id: 'IN2.25', description: 'Payor ID', subfields: 'CX' },
  { id: 'IN2.26', description: 'Payor Subscriber ID', subfields: 'CX' },
  { id: 'IN2.27', description: 'Eligibility Source', subfields: 'IS' },
  { id: 'IN2.28', description: 'Room Coverage Type/Amount', subfields: 'RMC' },
  { id: 'IN2.29', description: 'Policy Type/Amount', subfields: 'PTA' },
  { id: 'IN2.30', description: 'Daily Deductible', subfields: 'DDI' },
  { id: 'IN2.31', description: 'Living Dependency', subfields: 'IS' },
  { id: 'IN2.32', description: 'Ambulatory Status', subfields: 'IS' },
  { id: 'IN2.33', description: 'Citizenship', subfields: 'CE' },
  { id: 'IN2.34', description: 'Primary Language', subfields: 'CE' },
  { id: 'IN2.35', description: 'Living Arrangement', subfields: 'IS' },
  { id: 'IN2.36', description: 'Publicity Code', subfields: 'CE' },
  { id: 'IN2.37', description: 'Protection Indicator', subfields: 'ID' },
  { id: 'IN2.38', description: 'Student Indicator', subfields: 'IS' },
  { id: 'IN2.39', description: 'Religion', subfields: 'CE' },
  { id: 'IN2.40', description: "Mother's Maiden Name", subfields: 'XPN' },
  { id: 'IN2.41', description: 'Nationality', subfields: 'CE' },
  { id: 'IN2.42', description: 'Ethnic Group', subfields: 'CE' },
  { id: 'IN2.43', description: 'Marital Status', subfields: 'CE' },
  {
    id: 'IN2.44',
    description: "Insured's Employment Start Date",
    subfields: 'DT',
  },
  { id: 'IN2.45', description: 'Employment Stop Date', subfields: 'DT' },
  { id: 'IN2.46', description: 'Job Title', subfields: 'ST' },
  { id: 'IN2.47', description: 'Job Code/Class', subfields: 'JCC' },
  { id: 'IN2.48', description: 'Job Status', subfields: 'IS' },
  {
    id: 'IN2.49',
    description: 'Employer Contact Person Name',
    subfields: 'XPN',
  },
  {
    id: 'IN2.50',
    description: 'Employer Contact Person Phone Number',
    subfields: 'XTN',
  },
  { id: 'IN2.51', description: 'Employer Contact Reason', subfields: 'IS' },
  {
    id: 'IN2.52',
    description: "Insured's Contact Person's Name",
    subfields: 'XPN',
  },
  {
    id: 'IN2.53',
    description: "Insured's Contact Person Phone Number",
    subfields: 'XTN',
  },
  {
    id: 'IN2.54',
    description: "Insured's Contact Person Reason",
    subfields: 'IS',
  },
  {
    id: 'IN2.55',
    description: 'Relationship to the Patient Start Date',
    subfields: 'DT',
  },
  {
    id: 'IN2.56',
    description: 'Relationship to the Patient Stop Date',
    subfields: 'DT',
  },
  {
    id: 'IN2.57',
    description: 'Insurance Co. Contact Reason',
    subfields: 'IS',
  },
  {
    id: 'IN2.58',
    description: 'Insurance Co Contact Phone Number',
    subfields: 'XTN',
  },
  { id: 'IN2.59', description: 'Policy Scope', subfields: 'IS' },
  { id: 'IN2.60', description: 'Policy Source', subfields: 'IS' },
  { id: 'IN2.61', description: 'Patient Member Number', subfields: 'CX' },
  {
    id: 'IN2.62',
    description: "Guarantor's Relationship to Insured",
    subfields: 'CE',
  },
  {
    id: 'IN2.63',
    description: "Insured's Phone Number - Home",
    subfields: 'XTN',
  },
  {
    id: 'IN2.64',
    description: "Insured's Employer Phone Number",
    subfields: 'XTN',
  },
  {
    id: 'IN2.65',
    description: 'Military Handicapped Program',
    subfields: 'CE',
  },
  { id: 'IN2.66', description: 'Suspend Flag', subfields: 'ID' },
  { id: 'IN2.67', description: 'Copay Limit Flag', subfields: 'ID' },
  { id: 'IN2.68', description: 'Stoploss Limit Flag', subfields: 'ID' },
  {
    id: 'IN2.69',
    description: 'Insured Organization Name and ID',
    subfields: 'XON',
  },
  {
    id: 'IN2.70',
    description: 'Insured Employer Organization Name and ID',
    subfields: 'XON',
  },
  { id: 'IN2.71', description: 'Race', subfields: 'CE' },
  {
    id: 'IN2.72',
    description: "CMS Patient's Relationship to Insured",
    subfields: 'CE',
  },
  { id: 'IN3.1', description: 'Set ID - IN3', subfields: 'SI' },
  { id: 'IN3.2', description: 'Certification Number', subfields: 'CX' },
  { id: 'IN3.3', description: 'Certified By', subfields: 'XCN' },
  { id: 'IN3.4', description: 'Certification Required', subfields: 'ID' },
  { id: 'IN3.5', description: 'Penalty', subfields: 'MOP' },
  { id: 'IN3.6', description: 'Certification Date/Time', subfields: 'TS' },
  {
    id: 'IN3.7',
    description: 'Certification Modify Date/Time',
    subfields: 'TS',
  },
  { id: 'IN3.8', description: 'Operator', subfields: 'XCN' },
  { id: 'IN3.9', description: 'Certification Begin Date', subfields: 'DT' },
  { id: 'IN3.10', description: 'Certification End Date', subfields: 'DT' },
  { id: 'IN3.11', description: 'Days', subfields: 'DTN' },
  { id: 'IN3.12', description: 'Non-Concur Code/Description', subfields: 'CE' },
  {
    id: 'IN3.13',
    description: 'Non-Concur Effective Date/Time',
    subfields: 'TS',
  },
  { id: 'IN3.14', description: 'Physician Reviewer', subfields: 'XCN' },
  { id: 'IN3.15', description: 'Certification Contact', subfields: 'ST' },
  {
    id: 'IN3.16',
    description: 'Certification Contact Phone Number',
    subfields: 'XTN',
  },
  { id: 'IN3.17', description: 'Appeal Reason', subfields: 'CE' },
  { id: 'IN3.18', description: 'Certification Agency', subfields: 'CE' },
  {
    id: 'IN3.19',
    description: 'Certification Agency Phone Number',
    subfields: 'XTN',
  },
  {
    id: 'IN3.20',
    description: 'Pre-Certification Requirement',
    subfields: 'ICD',
  },
  { id: 'IN3.21', description: 'Case Manager', subfields: 'ST' },
  { id: 'IN3.22', description: 'Second Opinion Date', subfields: 'DT' },
  { id: 'IN3.23', description: 'Second Opinion Status', subfields: 'IS' },
  {
    id: 'IN3.24',
    description: 'Second Opinion Documentation Received',
    subfields: 'IS',
  },
  { id: 'IN3.25', description: 'Second Opinion Physician', subfields: 'XCN' },
  { id: 'INV.1', description: 'Substance Identifier', subfields: 'CE' },
  { id: 'INV.2', description: 'Substance Status', subfields: 'CE' },
  { id: 'INV.3', description: 'Substance Type', subfields: 'CE' },
  {
    id: 'INV.4',
    description: 'Inventory Container Identifier',
    subfields: 'CE',
  },
  { id: 'INV.5', description: 'Container Carrier Identifier', subfields: 'CE' },
  { id: 'INV.6', description: 'Position on Carrier', subfields: 'CE' },
  { id: 'INV.7', description: 'Initial Quantity', subfields: 'NM' },
  { id: 'INV.8', description: 'Current Quantity', subfields: 'NM' },
  { id: 'INV.9', description: 'Available Quantity', subfields: 'NM' },
  { id: 'INV.10', description: 'Consumption Quantity', subfields: 'NM' },
  { id: 'INV.11', description: 'Quantity Units', subfields: 'CE' },
  { id: 'INV.12', description: 'Expiration Date/Time', subfields: 'TS' },
  { id: 'INV.13', description: 'First Used Date/Time', subfields: 'TS' },
  { id: 'INV.14', description: 'On Board Stability Duration', subfields: 'TQ' },
  { id: 'INV.15', description: 'Test/Fluid Identifier(s)', subfields: 'CE' },
  { id: 'INV.16', description: 'Manufacturer Lot Number', subfields: 'ST' },
  { id: 'INV.17', description: 'Manufacturer Identifier', subfields: 'CE' },
  { id: 'INV.18', description: 'Supplier Identifier', subfields: 'CE' },
  { id: 'INV.19', description: 'On Board Stability Time', subfields: 'CQ' },
  { id: 'INV.20', description: 'Target Value', subfields: 'CQ' },
  { id: 'IPC.1', description: 'Accession Identifier', subfields: 'EI' },
  { id: 'IPC.2', description: 'Requested Procedure ID', subfields: 'EI' },
  { id: 'IPC.3', description: 'Study Instance UID', subfields: 'EI' },
  { id: 'IPC.4', description: 'Scheduled Procedure Step ID', subfields: 'EI' },
  { id: 'IPC.5', description: 'Modality', subfields: 'CE' },
  { id: 'IPC.6', description: 'Protocol Code', subfields: 'CE' },
  { id: 'IPC.7', description: 'Scheduled Station Name', subfields: 'EI' },
  {
    id: 'IPC.8',
    description: 'Scheduled Procedure Step Location',
    subfields: 'CE',
  },
  { id: 'IPC.9', description: 'Scheduled AE Title', subfields: 'ST' },
  {
    id: 'ISD.1',
    description: 'Reference Interaction Number (unique identifier)',
    subfields: 'NM',
  },
  { id: 'ISD.2', description: 'Interaction Type Identifier', subfields: 'CE' },
  { id: 'ISD.3', description: 'Interaction Active State', subfields: 'CE' },
  { id: 'LAN.1', description: 'Set ID - LAN', subfields: 'SI' },
  { id: 'LAN.2', description: 'Language Code', subfields: 'CE' },
  { id: 'LAN.3', description: 'Language Ability Code', subfields: 'CE' },
  { id: 'LAN.4', description: 'Language Proficiency Code', subfields: 'CE' },
  { id: 'LCC.1', description: 'Primary Key Value - LCC', subfields: 'PL' },
  { id: 'LCC.2', description: 'Location Department', subfields: 'CE' },
  { id: 'LCC.3', description: 'Accommodation Type', subfields: 'CE' },
  { id: 'LCC.4', description: 'Charge Code', subfields: 'CE' },
  { id: 'LCH.1', description: 'Primary Key Value - LCH', subfields: 'PL' },
  { id: 'LCH.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'LCH.3', description: 'Segment Unique Key', subfields: 'EI' },
  { id: 'LCH.4', description: 'Location Characteristic ID', subfields: 'CE' },
  {
    id: 'LCH.5',
    description: 'Location Characteristic Value-LCH',
    subfields: 'CE',
  },
  { id: 'LDP.1', description: 'Primary Key Value - LDP', subfields: 'PL' },
  { id: 'LDP.2', description: 'Location Department', subfields: 'CE' },
  { id: 'LDP.3', description: 'Location Service', subfields: 'IS' },
  { id: 'LDP.4', description: 'Specialty Type', subfields: 'CE' },
  { id: 'LDP.5', description: 'Valid Patient Classes', subfields: 'IS' },
  { id: 'LDP.6', description: 'Active/Inactive Flag', subfields: 'ID' },
  { id: 'LDP.7', description: 'Activation Date  LDP', subfields: 'TS' },
  { id: 'LDP.8', description: 'Inactivation Date - LDP', subfields: 'TS' },
  { id: 'LDP.9', description: 'Inactivated Reason', subfields: 'ST' },
  { id: 'LDP.10', description: 'Visiting Hours', subfields: 'VH' },
  { id: 'LDP.11', description: 'Contact Phone', subfields: 'XTN' },
  { id: 'LDP.12', description: 'Location Cost Center', subfields: 'CE' },
  { id: 'LOC.1', description: 'Primary Key Value - LOC', subfields: 'PL' },
  { id: 'LOC.2', description: 'Location Description', subfields: 'ST' },
  { id: 'LOC.3', description: 'Location Type - LOC', subfields: 'IS' },
  { id: 'LOC.4', description: 'Organization Name - LOC', subfields: 'XON' },
  { id: 'LOC.5', description: 'Location Address', subfields: 'XAD' },
  { id: 'LOC.6', description: 'Location Phone', subfields: 'XTN' },
  { id: 'LOC.7', description: 'License Number', subfields: 'CE' },
  { id: 'LOC.8', description: 'Location Equipment', subfields: 'IS' },
  { id: 'LOC.9', description: 'Location Service Code', subfields: 'IS' },
  { id: 'LRL.1', description: 'Primary Key Value - LRL', subfields: 'PL' },
  { id: 'LRL.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'LRL.3', description: 'Segment Unique Key', subfields: 'EI' },
  { id: 'LRL.4', description: 'Location Relationship ID', subfields: 'CE' },
  {
    id: 'LRL.5',
    description: 'Organizational Location Relationship Value',
    subfields: 'XON',
  },
  {
    id: 'LRL.6',
    description: 'Patient Location Relationship Value',
    subfields: 'PL',
  },
  { id: 'MFA.1', description: 'Record-Level Event Code', subfields: 'ID' },
  { id: 'MFA.2', description: 'MFN Control ID', subfields: 'ST' },
  { id: 'MFA.3', description: 'Event Completion Date/Time', subfields: 'TS' },
  {
    id: 'MFA.4',
    description: 'MFN Record Level Error Return',
    subfields: 'CE',
  },
  { id: 'MFA.5', description: 'Primary Key Value - MFA', subfields: 'var' },
  { id: 'MFA.6', description: 'Primary Key Value Type - MFA', subfields: 'ID' },
  { id: 'MFE.1', description: 'Record-Level Event Code', subfields: 'ID' },
  { id: 'MFE.2', description: 'MFN Control ID', subfields: 'ST' },
  { id: 'MFE.3', description: 'Effective Date/Time', subfields: 'TS' },
  { id: 'MFE.4', description: 'Primary Key Value - MFE', subfields: 'var' },
  { id: 'MFE.5', description: 'Primary Key Value Type', subfields: 'ID' },
  { id: 'MFI.1', description: 'Master File Identifier', subfields: 'CE' },
  {
    id: 'MFI.2',
    description: 'Master File Application Identifier',
    subfields: 'HD',
  },
  { id: 'MFI.3', description: 'File-Level Event Code', subfields: 'ID' },
  { id: 'MFI.4', description: 'Entered Date/Time', subfields: 'TS' },
  { id: 'MFI.5', description: 'Effective Date/Time', subfields: 'TS' },
  { id: 'MFI.6', description: 'Response Level Code', subfields: 'ID' },
  {
    id: 'MRG.1',
    description: 'Prior Patient Identifier List',
    subfields: 'CX',
  },
  { id: 'MRG.2', description: 'Prior Alternate Patient ID', subfields: 'CX' },
  { id: 'MRG.3', description: 'Prior Patient Account Number', subfields: 'CX' },
  { id: 'MRG.4', description: 'Prior Patient ID', subfields: 'CX' },
  { id: 'MRG.5', description: 'Prior Visit Number', subfields: 'CX' },
  { id: 'MRG.6', description: 'Prior Alternate Visit ID', subfields: 'CX' },
  { id: 'MRG.7', description: 'Prior Patient Name', subfields: 'XPN' },
  { id: 'MSA.1', description: 'Acknowledgment Code', subfields: 'ID' },
  { id: 'MSA.2', description: 'Message Control ID', subfields: 'ST' },
  { id: 'MSA.3', description: 'Text Message', subfields: 'ST' },
  { id: 'MSA.4', description: 'Expected Sequence Number', subfields: 'NM' },
  { id: 'MSA.5', description: 'Delayed Acknowledgment Type', subfields: 'NUL' },
  { id: 'MSA.6', description: 'Error Condition', subfields: 'CE' },
  { id: 'MSH.1', description: 'Field Separator', subfields: 'ST' },
  { id: 'MSH.2', description: 'Encoding Characters', subfields: 'ST' },
  { id: 'MSH.3', description: 'Sending Application', subfields: 'HD' },
  { id: 'MSH.4', description: 'Sending Facility', subfields: 'HD' },
  { id: 'MSH.5', description: 'Receiving Application', subfields: 'HD' },
  { id: 'MSH.6', description: 'Receiving Facility', subfields: 'HD' },
  { id: 'MSH.7', description: 'Date/Time Of Message', subfields: 'TS' },
  { id: 'MSH.8', description: 'Security', subfields: 'ST' },
  { id: 'MSH.9', description: 'Message Type', subfields: 'MSG' },
  { id: 'MSH.10', description: 'Message Control ID', subfields: 'ST' },
  { id: 'MSH.11', description: 'Processing ID', subfields: 'PT' },
  { id: 'MSH.12', description: 'Version ID', subfields: 'VID' },
  { id: 'MSH.13', description: 'Sequence Number', subfields: 'NM' },
  { id: 'MSH.14', description: 'Continuation Pointer', subfields: 'ST' },
  { id: 'MSH.15', description: 'Accept Acknowledgment Type', subfields: 'ID' },
  {
    id: 'MSH.16',
    description: 'Application Acknowledgment Type',
    subfields: 'ID',
  },
  { id: 'MSH.17', description: 'Country Code', subfields: 'ID' },
  { id: 'MSH.18', description: 'Character Set', subfields: 'ID' },
  {
    id: 'MSH.19',
    description: 'Principal Language Of Message',
    subfields: 'CE',
  },
  {
    id: 'MSH.20',
    description: 'Alternate Character Set Handling Scheme',
    subfields: 'ID',
  },
  { id: 'MSH.21', description: 'Message Profile Identifier', subfields: 'EI' },
  { id: 'NCK.1', description: 'System Date/Time', subfields: 'TS' },
  {
    id: 'NDS.1',
    description: 'Notification Reference Number',
    subfields: 'NM',
  },
  { id: 'NDS.2', description: 'Notification Date/Time', subfields: 'TS' },
  { id: 'NDS.3', description: 'Notification Alert Severity', subfields: 'CE' },
  { id: 'NDS.4', description: 'Notification Code', subfields: 'CE' },
  { id: 'NK1.1', description: 'Set ID - NK1', subfields: 'SI' },
  { id: 'NK1.2', description: 'Name', subfields: 'XPN' },
  { id: 'NK1.3', description: 'Relationship', subfields: 'CE' },
  { id: 'NK1.4', description: 'Address', subfields: 'XAD' },
  { id: 'NK1.5', description: 'Phone Number', subfields: 'XTN' },
  { id: 'NK1.6', description: 'Business Phone Number', subfields: 'XTN' },
  { id: 'NK1.7', description: 'Contact Role', subfields: 'CE' },
  { id: 'NK1.8', description: 'Start Date', subfields: 'DT' },
  { id: 'NK1.9', description: 'End Date', subfields: 'DT' },
  {
    id: 'NK1.10',
    description: 'Next of Kin / Associated Parties Job Title',
    subfields: 'ST',
  },
  {
    id: 'NK1.11',
    description: 'Next of Kin / Associated Parties Job Code/Class',
    subfields: 'JCC',
  },
  {
    id: 'NK1.12',
    description: 'Next of Kin / Associated Parties Employee Number',
    subfields: 'CX',
  },
  { id: 'NK1.13', description: 'Organization Name - NK1', subfields: 'XON' },
  { id: 'NK1.14', description: 'Marital Status', subfields: 'CE' },
  { id: 'NK1.15', description: 'Administrative Sex', subfields: 'IS' },
  { id: 'NK1.16', description: 'Date/Time of Birth', subfields: 'TS' },
  { id: 'NK1.17', description: 'Living Dependency', subfields: 'IS' },
  { id: 'NK1.18', description: 'Ambulatory Status', subfields: 'IS' },
  { id: 'NK1.19', description: 'Citizenship', subfields: 'CE' },
  { id: 'NK1.20', description: 'Primary Language', subfields: 'CE' },
  { id: 'NK1.21', description: 'Living Arrangement', subfields: 'IS' },
  { id: 'NK1.22', description: 'Publicity Code', subfields: 'CE' },
  { id: 'NK1.23', description: 'Protection Indicator', subfields: 'ID' },
  { id: 'NK1.24', description: 'Student Indicator', subfields: 'IS' },
  { id: 'NK1.25', description: 'Religion', subfields: 'CE' },
  { id: 'NK1.26', description: "Mother's Maiden Name", subfields: 'XPN' },
  { id: 'NK1.27', description: 'Nationality', subfields: 'CE' },
  { id: 'NK1.28', description: 'Ethnic Group', subfields: 'CE' },
  { id: 'NK1.29', description: 'Contact Reason', subfields: 'CE' },
  { id: 'NK1.30', description: "Contact Person's Name", subfields: 'XPN' },
  {
    id: 'NK1.31',
    description: "Contact Person's Telephone Number",
    subfields: 'XTN',
  },
  { id: 'NK1.32', description: "Contact Person's Address", subfields: 'XAD' },
  {
    id: 'NK1.33',
    description: "Next of Kin/Associated Party's Identifiers",
    subfields: 'CX',
  },
  { id: 'NK1.34', description: 'Job Status', subfields: 'IS' },
  { id: 'NK1.35', description: 'Race', subfields: 'CE' },
  { id: 'NK1.36', description: 'Handicap', subfields: 'IS' },
  {
    id: 'NK1.37',
    description: 'Contact Person Social Security Number',
    subfields: 'ST',
  },
  { id: 'NK1.38', description: 'Next of Kin Birth Place', subfields: 'ST' },
  { id: 'NK1.39', description: 'VIP Indicator', subfields: 'IS' },
  { id: 'NPU.1', description: 'Bed Location', subfields: 'PL' },
  { id: 'NPU.2', description: 'Bed Status', subfields: 'IS' },
  { id: 'NSC.1', description: 'Application Change Type', subfields: 'IS' },
  { id: 'NSC.2', description: 'Current CPU', subfields: 'ST' },
  { id: 'NSC.3', description: 'Current Fileserver', subfields: 'ST' },
  { id: 'NSC.4', description: 'Current Application', subfields: 'HD' },
  { id: 'NSC.5', description: 'Current Facility', subfields: 'HD' },
  { id: 'NSC.6', description: 'New CPU', subfields: 'ST' },
  { id: 'NSC.7', description: 'New Fileserver', subfields: 'ST' },
  { id: 'NSC.8', description: 'New Application', subfields: 'HD' },
  { id: 'NSC.9', description: 'New Facility', subfields: 'HD' },
  { id: 'NST.1', description: 'Statistics Available', subfields: 'ID' },
  { id: 'NST.2', description: 'Source Identifier', subfields: 'ST' },
  { id: 'NST.3', description: 'Source Type', subfields: 'ID' },
  { id: 'NST.4', description: 'Statistics Start', subfields: 'TS' },
  { id: 'NST.5', description: 'Statistics End', subfields: 'TS' },
  { id: 'NST.6', description: 'Receive Character Count', subfields: 'NM' },
  { id: 'NST.7', description: 'Send Character Count', subfields: 'NM' },
  { id: 'NST.8', description: 'Messages Received', subfields: 'NM' },
  { id: 'NST.9', description: 'Messages Sent', subfields: 'NM' },
  { id: 'NST.10', description: 'Checksum Errors Received', subfields: 'NM' },
  { id: 'NST.11', description: 'Length Errors Received', subfields: 'NM' },
  { id: 'NST.12', description: 'Other Errors Received', subfields: 'NM' },
  { id: 'NST.13', description: 'Connect Timeouts', subfields: 'NM' },
  { id: 'NST.14', description: 'Receive Timeouts', subfields: 'NM' },
  {
    id: 'NST.15',
    description: 'Application control-level Errors',
    subfields: 'NM',
  },
  { id: 'NTE.1', description: 'Set ID - NTE', subfields: 'SI' },
  { id: 'NTE.2', description: 'Source of Comment', subfields: 'ID' },
  { id: 'NTE.3', description: 'Comment', subfields: 'FT' },
  { id: 'NTE.4', description: 'Comment Type', subfields: 'CE' },
  { id: 'OBR.1', description: 'Set ID - OBR', subfields: 'SI' },
  { id: 'OBR.2', description: 'Placer Order Number', subfields: 'EI' },
  { id: 'OBR.3', description: 'Filler Order Number', subfields: 'EI' },
  { id: 'OBR.4', description: 'Universal Service Identifier', subfields: 'CE' },
  { id: 'OBR.5', description: 'Priority - OBR', subfields: 'ID' },
  { id: 'OBR.6', description: 'Requested Date/Time', subfields: 'TS' },
  { id: 'OBR.7', description: 'Observation Date/Time', subfields: 'TS' },
  { id: 'OBR.8', description: 'Observation End Date/Time', subfields: 'TS' },
  { id: 'OBR.9', description: 'Collection Volume', subfields: 'CQ' },
  { id: 'OBR.10', description: 'Collector Identifier', subfields: 'XCN' },
  { id: 'OBR.11', description: 'Specimen Action Code', subfields: 'ID' },
  { id: 'OBR.12', description: 'Danger Code', subfields: 'CE' },
  {
    id: 'OBR.13',
    description: 'Relevant Clinical Information',
    subfields: 'ST',
  },
  { id: 'OBR.14', description: 'Specimen Received Date/Time', subfields: 'TS' },
  { id: 'OBR.15', description: 'Specimen Source', subfields: 'SPS' },
  { id: 'OBR.16', description: 'Ordering Provider', subfields: 'XCN' },
  {
    id: 'OBR.17',
    description: 'Order Callback Phone Number',
    subfields: 'XTN',
  },
  { id: 'OBR.18', description: 'Placer Field 1', subfields: 'ST' },
  { id: 'OBR.19', description: 'Placer Field 2', subfields: 'ST' },
  { id: 'OBR.20', description: 'Filler Field 1', subfields: 'ST' },
  { id: 'OBR.21', description: 'Filler Field 2', subfields: 'ST' },
  {
    id: 'OBR.22',
    description: 'Results Rpt/Status Chng - Date/Time',
    subfields: 'TS',
  },
  { id: 'OBR.23', description: 'Charge to Practice', subfields: 'MOC' },
  { id: 'OBR.24', description: 'Diagnostic Serv Sect ID', subfields: 'ID' },
  { id: 'OBR.25', description: 'Result Status', subfields: 'ID' },
  { id: 'OBR.26', description: 'Parent Result', subfields: 'PRL' },
  { id: 'OBR.27', description: 'Quantity/Timing', subfields: 'TQ' },
  { id: 'OBR.28', description: 'Result Copies To', subfields: 'XCN' },
  { id: 'OBR.29', description: 'Parent', subfields: 'EIP' },
  { id: 'OBR.30', description: 'Transportation Mode', subfields: 'ID' },
  { id: 'OBR.31', description: 'Reason for Study', subfields: 'CE' },
  {
    id: 'OBR.32',
    description: 'Principal Result Interpreter',
    subfields: 'NDL',
  },
  {
    id: 'OBR.33',
    description: 'Assistant Result Interpreter',
    subfields: 'NDL',
  },
  { id: 'OBR.34', description: 'Technician', subfields: 'NDL' },
  { id: 'OBR.35', description: 'Transcriptionist', subfields: 'NDL' },
  { id: 'OBR.36', description: 'Scheduled Date/Time', subfields: 'TS' },
  {
    id: 'OBR.37',
    description: 'Number of Sample Containers *',
    subfields: 'NM',
  },
  {
    id: 'OBR.38',
    description: 'Transport Logistics of Collected Sample',
    subfields: 'CE',
  },
  { id: 'OBR.39', description: "Collector's Comment *", subfields: 'CE' },
  {
    id: 'OBR.40',
    description: 'Transport Arrangement Responsibility',
    subfields: 'CE',
  },
  { id: 'OBR.41', description: 'Transport Arranged', subfields: 'ID' },
  { id: 'OBR.42', description: 'Escort Required', subfields: 'ID' },
  {
    id: 'OBR.43',
    description: 'Planned Patient Transport Comment',
    subfields: 'CE',
  },
  { id: 'OBR.44', description: 'Procedure Code', subfields: 'CE' },
  { id: 'OBR.45', description: 'Procedure Code Modifier', subfields: 'CE' },
  {
    id: 'OBR.46',
    description: 'Placer Supplemental Service Information',
    subfields: 'CE',
  },
  {
    id: 'OBR.47',
    description: 'Filler Supplemental Service Information',
    subfields: 'CE',
  },
  {
    id: 'OBR.48',
    description: 'Medically Necessary Duplicate Procedure Reason.',
    subfields: 'CWE',
  },
  { id: 'OBR.49', description: 'Result Handling', subfields: 'IS' },
  {
    id: 'OBR.50',
    description: 'Parent Universal Service Identifier',
    subfields: 'CWE',
  },
  { id: 'OBX.1', description: 'Set ID - OBX', subfields: 'SI' },
  { id: 'OBX.2', description: 'Value Type', subfields: 'ID' },
  { id: 'OBX.3', description: 'Observation Identifier', subfields: 'CE' },
  { id: 'OBX.4', description: 'Observation Sub-ID', subfields: 'ST' },
  { id: 'OBX.5', description: 'Observation Value', subfields: 'var' },
  { id: 'OBX.6', description: 'Units', subfields: 'CE' },
  { id: 'OBX.7', description: 'References Range', subfields: 'ST' },
  { id: 'OBX.8', description: 'Abnormal Flags', subfields: 'IS' },
  { id: 'OBX.9', description: 'Probability', subfields: 'NM' },
  { id: 'OBX.10', description: 'Nature of Abnormal Test', subfields: 'ID' },
  { id: 'OBX.11', description: 'Observation Result Status', subfields: 'ID' },
  {
    id: 'OBX.12',
    description: 'Effective Date of Reference Range Values',
    subfields: 'TS',
  },
  { id: 'OBX.13', description: 'User Defined Access Checks', subfields: 'ST' },
  {
    id: 'OBX.14',
    description: 'Date/Time of the Observation',
    subfields: 'TS',
  },
  { id: 'OBX.15', description: "Producer's Reference", subfields: 'CE' },
  { id: 'OBX.16', description: 'Responsible Observer', subfields: 'XCN' },
  { id: 'OBX.17', description: 'Observation Method', subfields: 'CE' },
  {
    id: 'OBX.18',
    description: 'Equipment Instance Identifier',
    subfields: 'EI',
  },
  { id: 'OBX.19', description: 'Date/Time of the Analysis', subfields: 'TS' },
  {
    id: 'OBX.20',
    description: 'Performing Organization Name',
    subfields: 'XON',
  },
  {
    id: 'OBX.21',
    description: 'Performing Organization Address',
    subfields: 'XAD',
  },
  {
    id: 'OBX.22',
    description: 'Performing Organization Medical Director',
    subfields: 'XCN',
  },
  { id: 'ODS.1', description: 'Type', subfields: 'ID' },
  { id: 'ODS.2', description: 'Service Period', subfields: 'CE' },
  {
    id: 'ODS.3',
    description: 'Diet, Supplement, or Preference Code',
    subfields: 'CE',
  },
  { id: 'ODS.4', description: 'Text Instruction', subfields: 'ST' },
  { id: 'ODT.1', description: 'Tray Type', subfields: 'CE' },
  { id: 'ODT.2', description: 'Service Period', subfields: 'CE' },
  { id: 'ODT.3', description: 'Text Instruction', subfields: 'ST' },
  {
    id: 'OM1.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  {
    id: 'OM1.2',
    description: "Producer's Service/Test/Observation ID",
    subfields: 'CE',
  },
  { id: 'OM1.3', description: 'Permitted Data Types', subfields: 'ID' },
  { id: 'OM1.4', description: 'Specimen Required', subfields: 'ID' },
  { id: 'OM1.5', description: 'Producer ID', subfields: 'CE' },
  { id: 'OM1.6', description: 'Observation Description', subfields: 'TX' },
  {
    id: 'OM1.7',
    description: 'Other Service/Test/Observation IDs for the Observation',
    subfields: 'CE',
  },
  { id: 'OM1.8', description: 'Other Names', subfields: 'ST' },
  {
    id: 'OM1.9',
    description: 'Preferred Report Name for the Observation',
    subfields: 'ST',
  },
  {
    id: 'OM1.10',
    description: 'Preferred Short Name or Mnemonic for Observation',
    subfields: 'ST',
  },
  {
    id: 'OM1.11',
    description: 'Preferred Long Name for the Observation',
    subfields: 'ST',
  },
  { id: 'OM1.12', description: 'Orderability', subfields: 'ID' },
  {
    id: 'OM1.13',
    description: 'Identity of Instrument Used to Perform this Study',
    subfields: 'CE',
  },
  {
    id: 'OM1.14',
    description: 'Coded Representation of Method',
    subfields: 'CE',
  },
  { id: 'OM1.15', description: 'Portable Device Indicator', subfields: 'ID' },
  {
    id: 'OM1.16',
    description: 'Observation Producing Department/Section',
    subfields: 'CE',
  },
  {
    id: 'OM1.17',
    description: 'Telephone Number of Section',
    subfields: 'XTN',
  },
  {
    id: 'OM1.18',
    description: 'Nature of Service/Test/Observation',
    subfields: 'IS',
  },
  { id: 'OM1.19', description: 'Report Subheader', subfields: 'CE' },
  { id: 'OM1.20', description: 'Report Display Order', subfields: 'ST' },
  {
    id: 'OM1.21',
    description:
      'Date/Time Stamp for any change in Definition for the Observation',
    subfields: 'TS',
  },
  {
    id: 'OM1.22',
    description: 'Effective Date/Time of Change',
    subfields: 'TS',
  },
  { id: 'OM1.23', description: 'Typical Turn-Around Time', subfields: 'NM' },
  { id: 'OM1.24', description: 'Processing Time', subfields: 'NM' },
  { id: 'OM1.25', description: 'Processing Priority', subfields: 'ID' },
  { id: 'OM1.26', description: 'Reporting Priority', subfields: 'ID' },
  {
    id: 'OM1.27',
    description: 'Outside Site(s) Where Observation may be Performed',
    subfields: 'CE',
  },
  { id: 'OM1.28', description: 'Address of Outside Site(s)', subfields: 'XAD' },
  {
    id: 'OM1.29',
    description: 'Phone Number of Outside Site',
    subfields: 'XTN',
  },
  { id: 'OM1.30', description: 'Confidentiality Code', subfields: 'CWE' },
  {
    id: 'OM1.31',
    description: 'Observations Required to Interpret the Observation',
    subfields: 'CE',
  },
  {
    id: 'OM1.32',
    description: 'Interpretation of Observations',
    subfields: 'TX',
  },
  {
    id: 'OM1.33',
    description: 'Contraindications to Observations',
    subfields: 'CE',
  },
  { id: 'OM1.34', description: 'Reflex Tests/Observations', subfields: 'CE' },
  {
    id: 'OM1.35',
    description: 'Rules that Trigger Reflex Testing',
    subfields: 'TX',
  },
  { id: 'OM1.36', description: 'Fixed Canned Message', subfields: 'CE' },
  { id: 'OM1.37', description: 'Patient Preparation', subfields: 'TX' },
  { id: 'OM1.38', description: 'Procedure Medication', subfields: 'CE' },
  {
    id: 'OM1.39',
    description: 'Factors that may Affect the Observation',
    subfields: 'TX',
  },
  {
    id: 'OM1.40',
    description: 'Service/Test/Observation Performance Schedule',
    subfields: 'ST',
  },
  { id: 'OM1.41', description: 'Description of Test Methods', subfields: 'TX' },
  { id: 'OM1.42', description: 'Kind of Quantity Observed', subfields: 'CE' },
  { id: 'OM1.43', description: 'Point Versus Interval', subfields: 'CE' },
  { id: 'OM1.44', description: 'Challenge Information', subfields: 'TX' },
  { id: 'OM1.45', description: 'Relationship Modifier', subfields: 'CE' },
  {
    id: 'OM1.46',
    description: 'Target Anatomic Site Of Test',
    subfields: 'CE',
  },
  {
    id: 'OM1.47',
    description: 'Modality Of Imaging Measurement',
    subfields: 'CE',
  },
  {
    id: 'OM2.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  { id: 'OM2.2', description: 'Units of Measure', subfields: 'CE' },
  { id: 'OM2.3', description: 'Range of Decimal Precision', subfields: 'NM' },
  {
    id: 'OM2.4',
    description: 'Corresponding SI Units of Measure',
    subfields: 'CE',
  },
  { id: 'OM2.5', description: 'SI Conversion Factor', subfields: 'TX' },
  {
    id: 'OM2.6',
    description:
      'Reference (Normal) Range - Ordinal and Continuous Observations',
    subfields: 'RFR',
  },
  {
    id: 'OM2.7',
    description: 'Critical Range for Ordinal and Continuous Observations',
    subfields: 'RFR',
  },
  {
    id: 'OM2.8',
    description: 'Absolute Range for Ordinal and Continuous Observations',
    subfields: 'RFR',
  },
  { id: 'OM2.9', description: 'Delta Check Criteria', subfields: 'DLT' },
  {
    id: 'OM2.10',
    description: 'Minimum Meaningful Increments',
    subfields: 'NM',
  },
  {
    id: 'OM3.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  { id: 'OM3.2', description: 'Preferred Coding System', subfields: 'CE' },
  { id: 'OM3.3', description: 'Valid Coded "Answers"', subfields: 'CE' },
  {
    id: 'OM3.4',
    description: 'Normal Text/Codes for Categorical Observations',
    subfields: 'CE',
  },
  {
    id: 'OM3.5',
    description: 'Abnormal Text/Codes for Categorical Observations',
    subfields: 'CE',
  },
  {
    id: 'OM3.6',
    description: 'Critical Text/Codes for Categorical Observations',
    subfields: 'CE',
  },
  { id: 'OM3.7', description: 'Value Type', subfields: 'ID' },
  {
    id: 'OM4.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  { id: 'OM4.2', description: 'Derived Specimen', subfields: 'ID' },
  { id: 'OM4.3', description: 'Container Description', subfields: 'TX' },
  { id: 'OM4.4', description: 'Container Volume', subfields: 'NM' },
  { id: 'OM4.5', description: 'Container Units', subfields: 'CE' },
  { id: 'OM4.6', description: 'Specimen', subfields: 'CE' },
  { id: 'OM4.7', description: 'Additive', subfields: 'CWE' },
  { id: 'OM4.8', description: 'Preparation', subfields: 'TX' },
  {
    id: 'OM4.9',
    description: 'Special Handling Requirements',
    subfields: 'TX',
  },
  { id: 'OM4.10', description: 'Normal Collection Volume', subfields: 'CQ' },
  { id: 'OM4.11', description: 'Minimum Collection Volume', subfields: 'CQ' },
  { id: 'OM4.12', description: 'Specimen Requirements', subfields: 'TX' },
  { id: 'OM4.13', description: 'Specimen Priorities', subfields: 'ID' },
  { id: 'OM4.14', description: 'Specimen Retention Time', subfields: 'CQ' },
  {
    id: 'OM5.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  {
    id: 'OM5.2',
    description: 'Test/Observations Included within an Ordered Test Battery',
    subfields: 'CE',
  },
  { id: 'OM5.3', description: 'Observation ID Suffixes', subfields: 'ST' },
  {
    id: 'OM6.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  { id: 'OM6.2', description: 'Derivation Rule', subfields: 'TX' },
  {
    id: 'OM7.1',
    description: 'Sequence Number - Test/Observation Master File',
    subfields: 'NM',
  },
  { id: 'OM7.2', description: 'Universal Service Identifier', subfields: 'CE' },
  { id: 'OM7.3', description: 'Category Identifier', subfields: 'CE' },
  { id: 'OM7.4', description: 'Category Description', subfields: 'TX' },
  { id: 'OM7.5', description: 'Category Synonym', subfields: 'ST' },
  {
    id: 'OM7.6',
    description: 'Effective Test/Service Start Date/Time',
    subfields: 'TS',
  },
  {
    id: 'OM7.7',
    description: 'Effective Test/Service End Date/Time',
    subfields: 'TS',
  },
  {
    id: 'OM7.8',
    description: 'Test/Service Default Duration Quantity',
    subfields: 'NM',
  },
  {
    id: 'OM7.9',
    description: 'Test/Service Default Duration Units',
    subfields: 'CE',
  },
  {
    id: 'OM7.10',
    description: 'Test/Service Default Frequency',
    subfields: 'IS',
  },
  { id: 'OM7.11', description: 'Consent Indicator', subfields: 'ID' },
  { id: 'OM7.12', description: 'Consent Identifier', subfields: 'CE' },
  {
    id: 'OM7.13',
    description: 'Consent Effective Start Date/Time',
    subfields: 'TS',
  },
  {
    id: 'OM7.14',
    description: 'Consent Effective End Date/Time',
    subfields: 'TS',
  },
  { id: 'OM7.15', description: 'Consent Interval Quantity', subfields: 'NM' },
  { id: 'OM7.16', description: 'Consent Interval Units', subfields: 'CE' },
  {
    id: 'OM7.17',
    description: 'Consent Waiting Period Quantity',
    subfields: 'NM',
  },
  {
    id: 'OM7.18',
    description: 'Consent Waiting Period Units',
    subfields: 'CE',
  },
  {
    id: 'OM7.19',
    description: 'Effective Date/Time of Change',
    subfields: 'TS',
  },
  { id: 'OM7.20', description: 'Entered By', subfields: 'XCN' },
  { id: 'OM7.21', description: 'Orderable-at Location', subfields: 'PL' },
  { id: 'OM7.22', description: 'Formulary Status', subfields: 'IS' },
  { id: 'OM7.23', description: 'Special Order Indicator', subfields: 'ID' },
  { id: 'OM7.24', description: 'Primary Key Value - CDM', subfields: 'CE' },
  { id: 'ORC.1', description: 'Order Control', subfields: 'ID' },
  { id: 'ORC.2', description: 'Placer Order Number', subfields: 'EI' },
  { id: 'ORC.3', description: 'Filler Order Number', subfields: 'EI' },
  { id: 'ORC.4', description: 'Placer Group Number', subfields: 'EI' },
  { id: 'ORC.5', description: 'Order Status', subfields: 'ID' },
  { id: 'ORC.6', description: 'Response Flag', subfields: 'ID' },
  { id: 'ORC.7', description: 'Quantity/Timing', subfields: 'TQ' },
  { id: 'ORC.8', description: 'Parent', subfields: 'EIP' },
  { id: 'ORC.9', description: 'Date/Time of Transaction', subfields: 'TS' },
  { id: 'ORC.10', description: 'Entered By', subfields: 'XCN' },
  { id: 'ORC.11', description: 'Verified By', subfields: 'XCN' },
  { id: 'ORC.12', description: 'Ordering Provider', subfields: 'XCN' },
  { id: 'ORC.13', description: "Enterer's Location", subfields: 'PL' },
  { id: 'ORC.14', description: 'Call Back Phone Number', subfields: 'XTN' },
  { id: 'ORC.15', description: 'Order Effective Date/Time', subfields: 'TS' },
  { id: 'ORC.16', description: 'Order Control Code Reason', subfields: 'CE' },
  { id: 'ORC.17', description: 'Entering Organization', subfields: 'CE' },
  { id: 'ORC.18', description: 'Entering Device', subfields: 'CE' },
  { id: 'ORC.19', description: 'Action By', subfields: 'XCN' },
  {
    id: 'ORC.20',
    description: 'Advanced Beneficiary Notice Code',
    subfields: 'CE',
  },
  { id: 'ORC.21', description: 'Ordering Facility Name', subfields: 'XON' },
  { id: 'ORC.22', description: 'Ordering Facility Address', subfields: 'XAD' },
  {
    id: 'ORC.23',
    description: 'Ordering Facility Phone Number',
    subfields: 'XTN',
  },
  { id: 'ORC.24', description: 'Ordering Provider Address', subfields: 'XAD' },
  { id: 'ORC.25', description: 'Order Status Modifier', subfields: 'CWE' },
  {
    id: 'ORC.26',
    description: 'Advanced Beneficiary Notice Override Reason',
    subfields: 'CWE',
  },
  {
    id: 'ORC.27',
    description: "Filler's Expected Availability Date/Time",
    subfields: 'TS',
  },
  { id: 'ORC.28', description: 'Confidentiality Code', subfields: 'CWE' },
  { id: 'ORC.29', description: 'Order Type', subfields: 'CWE' },
  { id: 'ORC.30', description: 'Enterer Authorization Mode', subfields: 'CNE' },
  {
    id: 'ORC.31',
    description: 'Parent Universal Service Identifier',
    subfields: 'CWE',
  },
  { id: 'ORG.1', description: 'Set ID - ORG', subfields: 'SI' },
  { id: 'ORG.2', description: 'Organization Unit Code', subfields: 'CE' },
  { id: 'ORG.3', description: 'Organization Unit Type Code', subfields: 'CE' },
  { id: 'ORG.4', description: 'Primary Org Unit Indicator', subfields: 'ID' },
  {
    id: 'ORG.5',
    description: 'Practitioner Org Unit Identifier',
    subfields: 'CX',
  },
  {
    id: 'ORG.6',
    description: 'Health Care Provider Type Code',
    subfields: 'CE',
  },
  {
    id: 'ORG.7',
    description: 'Health Care Provider Classification Code',
    subfields: 'CE',
  },
  {
    id: 'ORG.8',
    description: 'Health Care Provider Area of Specialization Code',
    subfields: 'CE',
  },
  { id: 'ORG.9', description: 'Effective Date Range', subfields: 'DR' },
  { id: 'ORG.10', description: 'Employment Status Code', subfields: 'CE' },
  { id: 'ORG.11', description: 'Board Approval Indicator', subfields: 'ID' },
  {
    id: 'ORG.12',
    description: 'Primary Care Physician Indicator',
    subfields: 'ID',
  },
  { id: 'OVR.1', description: 'Business Rule Override Type', subfields: 'CWE' },
  { id: 'OVR.2', description: 'Business Rule Override Code', subfields: 'CWE' },
  { id: 'OVR.3', description: 'Override Comments', subfields: 'TX' },
  { id: 'OVR.4', description: 'Override Entered By', subfields: 'XCN' },
  { id: 'OVR.5', description: 'Override Authorized By', subfields: 'XCN' },
  { id: 'PCR.1', description: 'Implicated Product', subfields: 'CE' },
  { id: 'PCR.2', description: 'Generic Product', subfields: 'IS' },
  { id: 'PCR.3', description: 'Product Class', subfields: 'CE' },
  { id: 'PCR.4', description: 'Total Duration Of Therapy', subfields: 'CQ' },
  { id: 'PCR.5', description: 'Product Manufacture Date', subfields: 'TS' },
  { id: 'PCR.6', description: 'Product Expiration Date', subfields: 'TS' },
  { id: 'PCR.7', description: 'Product Implantation Date', subfields: 'TS' },
  { id: 'PCR.8', description: 'Product Explantation Date', subfields: 'TS' },
  { id: 'PCR.9', description: 'Single Use Device', subfields: 'IS' },
  { id: 'PCR.10', description: 'Indication For Product Use', subfields: 'CE' },
  { id: 'PCR.11', description: 'Product Problem', subfields: 'IS' },
  { id: 'PCR.12', description: 'Product Serial/Lot Number', subfields: 'ST' },
  {
    id: 'PCR.13',
    description: 'Product Available For Inspection',
    subfields: 'IS',
  },
  {
    id: 'PCR.14',
    description: 'Product Evaluation Performed',
    subfields: 'CE',
  },
  { id: 'PCR.15', description: 'Product Evaluation Status', subfields: 'CE' },
  { id: 'PCR.16', description: 'Product Evaluation Results', subfields: 'CE' },
  { id: 'PCR.17', description: 'Evaluated Product Source', subfields: 'ID' },
  {
    id: 'PCR.18',
    description: 'Date Product Returned To Manufacturer',
    subfields: 'TS',
  },
  {
    id: 'PCR.19',
    description: 'Device Operator Qualifications',
    subfields: 'ID',
  },
  { id: 'PCR.20', description: 'Relatedness Assessment', subfields: 'ID' },
  {
    id: 'PCR.21',
    description: 'Action Taken In Response To The Event',
    subfields: 'ID',
  },
  {
    id: 'PCR.22',
    description: 'Event Causality Observations',
    subfields: 'ID',
  },
  { id: 'PCR.23', description: 'Indirect Exposure Mechanism', subfields: 'ID' },
  { id: 'PD1.1', description: 'Living Dependency', subfields: 'IS' },
  { id: 'PD1.2', description: 'Living Arrangement', subfields: 'IS' },
  { id: 'PD1.3', description: 'Patient Primary Facility', subfields: 'XON' },
  {
    id: 'PD1.4',
    description: 'Patient Primary Care Provider Name & ID No.',
    subfields: 'XCN',
  },
  { id: 'PD1.5', description: 'Student Indicator', subfields: 'IS' },
  { id: 'PD1.6', description: 'Handicap', subfields: 'IS' },
  { id: 'PD1.7', description: 'Living Will Code', subfields: 'IS' },
  { id: 'PD1.8', description: 'Organ Donor Code', subfields: 'IS' },
  { id: 'PD1.9', description: 'Separate Bill', subfields: 'ID' },
  { id: 'PD1.10', description: 'Duplicate Patient', subfields: 'CX' },
  { id: 'PD1.11', description: 'Publicity Code', subfields: 'CE' },
  { id: 'PD1.12', description: 'Protection Indicator', subfields: 'ID' },
  {
    id: 'PD1.13',
    description: 'Protection Indicator Effective Date',
    subfields: 'DT',
  },
  { id: 'PD1.14', description: 'Place of Worship', subfields: 'XON' },
  { id: 'PD1.15', description: 'Advance Directive Code', subfields: 'CE' },
  {
    id: 'PD1.16',
    description: 'Immunization Registry Status',
    subfields: 'IS',
  },
  {
    id: 'PD1.17',
    description: 'Immunization Registry Status Effective Date',
    subfields: 'DT',
  },
  {
    id: 'PD1.18',
    description: 'Publicity Code Effective Date',
    subfields: 'DT',
  },
  { id: 'PD1.19', description: 'Military Branch', subfields: 'IS' },
  { id: 'PD1.20', description: 'Military Rank/Grade', subfields: 'IS' },
  { id: 'PD1.21', description: 'Military Status', subfields: 'IS' },
  { id: 'PDA.1', description: 'Death Cause Code', subfields: 'CE' },
  { id: 'PDA.2', description: 'Death Location', subfields: 'PL' },
  { id: 'PDA.3', description: 'Death Certified Indicator', subfields: 'ID' },
  {
    id: 'PDA.4',
    description: 'Death Certificate Signed Date/Time',
    subfields: 'TS',
  },
  { id: 'PDA.5', description: 'Death Certified By', subfields: 'XCN' },
  { id: 'PDA.6', description: 'Autopsy Indicator', subfields: 'ID' },
  {
    id: 'PDA.7',
    description: 'Autopsy Start and End Date/Time',
    subfields: 'DR',
  },
  { id: 'PDA.8', description: 'Autopsy Performed By', subfields: 'XCN' },
  { id: 'PDA.9', description: 'Coroner Indicator', subfields: 'ID' },
  { id: 'PDC.1', description: 'Manufacturer/Distributor', subfields: 'XON' },
  { id: 'PDC.2', description: 'Country', subfields: 'CE' },
  { id: 'PDC.3', description: 'Brand Name', subfields: 'ST' },
  { id: 'PDC.4', description: 'Device Family Name', subfields: 'ST' },
  { id: 'PDC.5', description: 'Generic Name', subfields: 'CE' },
  { id: 'PDC.6', description: 'Model Identifier', subfields: 'ST' },
  { id: 'PDC.7', description: 'Catalogue Identifier', subfields: 'ST' },
  { id: 'PDC.8', description: 'Other Identifier', subfields: 'ST' },
  { id: 'PDC.9', description: 'Product Code', subfields: 'CE' },
  { id: 'PDC.10', description: 'Marketing Basis', subfields: 'ID' },
  { id: 'PDC.11', description: 'Marketing Approval ID', subfields: 'ST' },
  { id: 'PDC.12', description: 'Labeled Shelf Life', subfields: 'CQ' },
  { id: 'PDC.13', description: 'Expected Shelf Life', subfields: 'CQ' },
  { id: 'PDC.14', description: 'Date First Marketed', subfields: 'TS' },
  { id: 'PDC.15', description: 'Date Last Marketed', subfields: 'TS' },
  { id: 'PEO.1', description: 'Event Identifiers Used', subfields: 'CE' },
  { id: 'PEO.2', description: 'Event Symptom/Diagnosis Code', subfields: 'CE' },
  { id: 'PEO.3', description: 'Event Onset Date/Time', subfields: 'TS' },
  { id: 'PEO.4', description: 'Event Exacerbation Date/Time', subfields: 'TS' },
  { id: 'PEO.5', description: 'Event Improved Date/Time', subfields: 'TS' },
  { id: 'PEO.6', description: 'Event Ended Data/Time', subfields: 'TS' },
  {
    id: 'PEO.7',
    description: 'Event Location Occurred Address',
    subfields: 'XAD',
  },
  { id: 'PEO.8', description: 'Event Qualification', subfields: 'ID' },
  { id: 'PEO.9', description: 'Event Serious', subfields: 'ID' },
  { id: 'PEO.10', description: 'Event Expected', subfields: 'ID' },
  { id: 'PEO.11', description: 'Event Outcome', subfields: 'ID' },
  { id: 'PEO.12', description: 'Patient Outcome', subfields: 'ID' },
  {
    id: 'PEO.13',
    description: 'Event Description From Others',
    subfields: 'FT',
  },
  {
    id: 'PEO.14',
    description: 'Event From Original Reporter',
    subfields: 'FT',
  },
  {
    id: 'PEO.15',
    description: 'Event Description From Patient',
    subfields: 'FT',
  },
  {
    id: 'PEO.16',
    description: 'Event Description From Practitioner',
    subfields: 'FT',
  },
  {
    id: 'PEO.17',
    description: 'Event Description From Autopsy',
    subfields: 'FT',
  },
  { id: 'PEO.18', description: 'Cause Of Death', subfields: 'CE' },
  { id: 'PEO.19', description: 'Primary Observer Name', subfields: 'XPN' },
  { id: 'PEO.20', description: 'Primary Observer Address', subfields: 'XAD' },
  { id: 'PEO.21', description: 'Primary Observer Telephone', subfields: 'XTN' },
  {
    id: 'PEO.22',
    description: "Primary Observer's Qualification",
    subfields: 'ID',
  },
  { id: 'PEO.23', description: 'Confirmation Provided By', subfields: 'ID' },
  {
    id: 'PEO.24',
    description: 'Primary Observer Aware Date/Time',
    subfields: 'TS',
  },
  {
    id: 'PEO.25',
    description: "Primary Observer's identity May Be Divulged",
    subfields: 'ID',
  },
  { id: 'PES.1', description: 'Sender Organization Name', subfields: 'XON' },
  { id: 'PES.2', description: 'Sender Individual Name', subfields: 'XCN' },
  { id: 'PES.3', description: 'Sender Address', subfields: 'XAD' },
  { id: 'PES.4', description: 'Sender Telephone', subfields: 'XTN' },
  { id: 'PES.5', description: 'Sender Event Identifier', subfields: 'EI' },
  { id: 'PES.6', description: 'Sender Sequence Number', subfields: 'NM' },
  { id: 'PES.7', description: 'Sender Event Description', subfields: 'FT' },
  { id: 'PES.8', description: 'Sender Comment', subfields: 'FT' },
  { id: 'PES.9', description: 'Sender Aware Date/Time', subfields: 'TS' },
  { id: 'PES.10', description: 'Event Report Date', subfields: 'TS' },
  { id: 'PES.11', description: 'Event Report Timing/Type', subfields: 'ID' },
  { id: 'PES.12', description: 'Event Report Source', subfields: 'ID' },
  { id: 'PES.13', description: 'Event Reported To', subfields: 'ID' },
  { id: 'PID.1', description: 'Set ID - PID', subfields: 'SI' },
  { id: 'PID.2', description: 'Patient ID', subfields: 'CX' },
  { id: 'PID.3', description: 'Patient Identifier List', subfields: 'CX' },
  { id: 'PID.4', description: 'Alternate Patient ID - PID', subfields: 'CX' },
  { id: 'PID.5', description: 'Patient Name', subfields: 'XPN' },
  { id: 'PID.6', description: "Mother's Maiden Name", subfields: 'XPN' },
  { id: 'PID.7', description: 'Date/Time of Birth', subfields: 'TS' },
  { id: 'PID.8', description: 'Administrative Sex', subfields: 'IS' },
  { id: 'PID.9', description: 'Patient Alias', subfields: 'XPN' },
  { id: 'PID.10', description: 'Race', subfields: 'CE' },
  { id: 'PID.11', description: 'Patient Address', subfields: 'XAD' },
  { id: 'PID.12', description: 'County Code', subfields: 'IS' },
  { id: 'PID.13', description: 'Phone Number - Home', subfields: 'XTN' },
  { id: 'PID.14', description: 'Phone Number - Business', subfields: 'XTN' },
  { id: 'PID.15', description: 'Primary Language', subfields: 'CE' },
  { id: 'PID.16', description: 'Marital Status', subfields: 'CE' },
  { id: 'PID.17', description: 'Religion', subfields: 'CE' },
  { id: 'PID.18', description: 'Patient Account Number', subfields: 'CX' },
  { id: 'PID.19', description: 'SSN Number - Patient', subfields: 'ST' },
  {
    id: 'PID.20',
    description: "Driver's License Number - Patient",
    subfields: 'DLN',
  },
  { id: 'PID.21', description: "Mother's Identifier", subfields: 'CX' },
  { id: 'PID.22', description: 'Ethnic Group', subfields: 'CE' },
  { id: 'PID.23', description: 'Birth Place', subfields: 'ST' },
  { id: 'PID.24', description: 'Multiple Birth Indicator', subfields: 'ID' },
  { id: 'PID.25', description: 'Birth Order', subfields: 'NM' },
  { id: 'PID.26', description: 'Citizenship', subfields: 'CE' },
  { id: 'PID.27', description: 'Veterans Military Status', subfields: 'CE' },
  { id: 'PID.28', description: 'Nationality', subfields: 'CE' },
  { id: 'PID.29', description: 'Patient Death Date and Time', subfields: 'TS' },
  { id: 'PID.30', description: 'Patient Death Indicator', subfields: 'ID' },
  { id: 'PID.31', description: 'Identity Unknown Indicator', subfields: 'ID' },
  { id: 'PID.32', description: 'Identity Reliability Code', subfields: 'IS' },
  { id: 'PID.33', description: 'Last Update Date/Time', subfields: 'TS' },
  { id: 'PID.34', description: 'Last Update Facility', subfields: 'HD' },
  { id: 'PID.35', description: 'Species Code', subfields: 'CE' },
  { id: 'PID.36', description: 'Breed Code', subfields: 'CE' },
  { id: 'PID.37', description: 'Strain', subfields: 'ST' },
  { id: 'PID.38', description: 'Production Class Code', subfields: 'CE' },
  { id: 'PID.39', description: 'Tribal Citizenship', subfields: 'CWE' },
  { id: 'PR1.1', description: 'Set ID - PR1', subfields: 'SI' },
  { id: 'PR1.2', description: 'Procedure Coding Method', subfields: 'IS' },
  { id: 'PR1.3', description: 'Procedure Code', subfields: 'CE' },
  { id: 'PR1.4', description: 'Procedure Description', subfields: 'ST' },
  { id: 'PR1.5', description: 'Procedure Date/Time', subfields: 'TS' },
  { id: 'PR1.6', description: 'Procedure Functional Type', subfields: 'IS' },
  { id: 'PR1.7', description: 'Procedure Minutes', subfields: 'NM' },
  { id: 'PR1.8', description: 'Anesthesiologist', subfields: 'XCN' },
  { id: 'PR1.9', description: 'Anesthesia Code', subfields: 'IS' },
  { id: 'PR1.10', description: 'Anesthesia Minutes', subfields: 'NM' },
  { id: 'PR1.11', description: 'Surgeon', subfields: 'XCN' },
  { id: 'PR1.12', description: 'Procedure Practitioner', subfields: 'XCN' },
  { id: 'PR1.13', description: 'Consent Code', subfields: 'CE' },
  { id: 'PR1.14', description: 'Procedure Priority', subfields: 'ID' },
  { id: 'PR1.15', description: 'Associated Diagnosis Code', subfields: 'CE' },
  { id: 'PR1.16', description: 'Procedure Code Modifier', subfields: 'CE' },
  { id: 'PR1.17', description: 'Procedure DRG Type', subfields: 'IS' },
  { id: 'PR1.18', description: 'Tissue Type Code', subfields: 'CE' },
  { id: 'PR1.19', description: 'Procedure Identifier', subfields: 'EI' },
  { id: 'PR1.20', description: 'Procedure Action Code', subfields: 'ID' },
  { id: 'PRA.1', description: 'Primary Key Value - PRA', subfields: 'CE' },
  { id: 'PRA.2', description: 'Practitioner Group', subfields: 'CE' },
  { id: 'PRA.3', description: 'Practitioner Category', subfields: 'IS' },
  { id: 'PRA.4', description: 'Provider Billing', subfields: 'ID' },
  { id: 'PRA.5', description: 'Specialty', subfields: 'SPD' },
  { id: 'PRA.6', description: 'Practitioner ID Numbers', subfields: 'PLN' },
  { id: 'PRA.7', description: 'Privileges', subfields: 'PIP' },
  { id: 'PRA.8', description: 'Date Entered Practice', subfields: 'DT' },
  { id: 'PRA.9', description: 'Institution', subfields: 'CE' },
  { id: 'PRA.10', description: 'Date Left Practice', subfields: 'DT' },
  {
    id: 'PRA.11',
    description: 'Government Reimbursement Billing Eligibility',
    subfields: 'CE',
  },
  { id: 'PRA.12', description: 'Set ID - PRA', subfields: 'SI' },
  { id: 'PRB.1', description: 'Action Code', subfields: 'ID' },
  { id: 'PRB.2', description: 'Action Date/Time', subfields: 'TS' },
  { id: 'PRB.3', description: 'Problem ID', subfields: 'CE' },
  { id: 'PRB.4', description: 'Problem Instance ID', subfields: 'EI' },
  { id: 'PRB.5', description: 'Episode of Care ID', subfields: 'EI' },
  { id: 'PRB.6', description: 'Problem List Priority', subfields: 'NM' },
  {
    id: 'PRB.7',
    description: 'Problem Established Date/Time',
    subfields: 'TS',
  },
  {
    id: 'PRB.8',
    description: 'Anticipated Problem Resolution Date/Time',
    subfields: 'TS',
  },
  {
    id: 'PRB.9',
    description: 'Actual Problem Resolution Date/Time',
    subfields: 'TS',
  },
  { id: 'PRB.10', description: 'Problem Classification', subfields: 'CE' },
  {
    id: 'PRB.11',
    description: 'Problem Management Discipline',
    subfields: 'CE',
  },
  { id: 'PRB.12', description: 'Problem Persistence', subfields: 'CE' },
  { id: 'PRB.13', description: 'Problem Confirmation Status', subfields: 'CE' },
  { id: 'PRB.14', description: 'Problem Life Cycle Status', subfields: 'CE' },
  {
    id: 'PRB.15',
    description: 'Problem Life Cycle Status Date/Time',
    subfields: 'TS',
  },
  { id: 'PRB.16', description: 'Problem Date of Onset', subfields: 'TS' },
  { id: 'PRB.17', description: 'Problem Onset Text', subfields: 'ST' },
  { id: 'PRB.18', description: 'Problem Ranking', subfields: 'CE' },
  { id: 'PRB.19', description: 'Certainty of Problem', subfields: 'CE' },
  {
    id: 'PRB.20',
    description: 'Probability of Problem (0-1)',
    subfields: 'NM',
  },
  {
    id: 'PRB.21',
    description: 'Individual Awareness of Problem',
    subfields: 'CE',
  },
  { id: 'PRB.22', description: 'Problem Prognosis', subfields: 'CE' },
  {
    id: 'PRB.23',
    description: 'Individual Awareness of Prognosis',
    subfields: 'CE',
  },
  {
    id: 'PRB.24',
    description: 'Family/Significant Other Awareness of Problem/Prognosis',
    subfields: 'ST',
  },
  { id: 'PRB.25', description: 'Security/Sensitivity', subfields: 'CE' },
  { id: 'PRC.1', description: 'Primary Key Value - PRC', subfields: 'CE' },
  { id: 'PRC.2', description: 'Facility ID - PRC', subfields: 'CE' },
  { id: 'PRC.3', description: 'Department', subfields: 'CE' },
  { id: 'PRC.4', description: 'Valid Patient Classes', subfields: 'IS' },
  { id: 'PRC.5', description: 'Price', subfields: 'CP' },
  { id: 'PRC.6', description: 'Formula', subfields: 'ST' },
  { id: 'PRC.7', description: 'Minimum Quantity', subfields: 'NM' },
  { id: 'PRC.8', description: 'Maximum Quantity', subfields: 'NM' },
  { id: 'PRC.9', description: 'Minimum Price', subfields: 'MO' },
  { id: 'PRC.10', description: 'Maximum Price', subfields: 'MO' },
  { id: 'PRC.11', description: 'Effective Start Date', subfields: 'TS' },
  { id: 'PRC.12', description: 'Effective End Date', subfields: 'TS' },
  { id: 'PRC.13', description: 'Price Override Flag', subfields: 'IS' },
  { id: 'PRC.14', description: 'Billing Category', subfields: 'CE' },
  { id: 'PRC.15', description: 'Chargeable Flag', subfields: 'ID' },
  { id: 'PRC.16', description: 'Active/Inactive Flag', subfields: 'ID' },
  { id: 'PRC.17', description: 'Cost', subfields: 'MO' },
  { id: 'PRC.18', description: 'Charge On Indicator', subfields: 'IS' },
  { id: 'PRD.1', description: 'Provider Role', subfields: 'CE' },
  { id: 'PRD.2', description: 'Provider Name', subfields: 'XPN' },
  { id: 'PRD.3', description: 'Provider Address', subfields: 'XAD' },
  { id: 'PRD.4', description: 'Provider Location', subfields: 'PL' },
  {
    id: 'PRD.5',
    description: 'Provider Communication Information',
    subfields: 'XTN',
  },
  { id: 'PRD.6', description: 'Preferred Method of Contact', subfields: 'CE' },
  { id: 'PRD.7', description: 'Provider Identifiers', subfields: 'PLN' },
  {
    id: 'PRD.8',
    description: 'Effective Start Date of Provider Role',
    subfields: 'TS',
  },
  {
    id: 'PRD.9',
    description: 'Effective End Date of Provider Role',
    subfields: 'TS',
  },
  { id: 'PSH.1', description: 'Report Type', subfields: 'ST' },
  { id: 'PSH.2', description: 'Report Form Identifier', subfields: 'ST' },
  { id: 'PSH.3', description: 'Report Date', subfields: 'TS' },
  { id: 'PSH.4', description: 'Report Interval Start Date', subfields: 'TS' },
  { id: 'PSH.5', description: 'Report Interval End Date', subfields: 'TS' },
  { id: 'PSH.6', description: 'Quantity Manufactured', subfields: 'CQ' },
  { id: 'PSH.7', description: 'Quantity Distributed', subfields: 'CQ' },
  { id: 'PSH.8', description: 'Quantity Distributed Method', subfields: 'ID' },
  { id: 'PSH.9', description: 'Quantity Distributed Comment', subfields: 'FT' },
  { id: 'PSH.10', description: 'Quantity in Use', subfields: 'CQ' },
  { id: 'PSH.11', description: 'Quantity in Use Method', subfields: 'ID' },
  { id: 'PSH.12', description: 'Quantity in Use Comment', subfields: 'FT' },
  {
    id: 'PSH.13',
    description: 'Number of Product Experience Reports Filed by Facility',
    subfields: 'NM',
  },
  {
    id: 'PSH.14',
    description: 'Number of Product Experience Reports Filed by Distributor',
    subfields: 'NM',
  },
  { id: 'PTH.1', description: 'Action Code', subfields: 'ID' },
  { id: 'PTH.2', description: 'Pathway ID', subfields: 'CE' },
  { id: 'PTH.3', description: 'Pathway Instance ID', subfields: 'EI' },
  {
    id: 'PTH.4',
    description: 'Pathway Established Date/Time',
    subfields: 'TS',
  },
  { id: 'PTH.5', description: 'Pathway Life Cycle Status', subfields: 'CE' },
  {
    id: 'PTH.6',
    description: 'Change Pathway Life Cycle Status Date/Time',
    subfields: 'TS',
  },
  { id: 'PV1.1', description: 'Set ID - PV1', subfields: 'SI' },
  { id: 'PV1.2', description: 'Patient Class', subfields: 'IS' },
  { id: 'PV1.3', description: 'Assigned Patient Location', subfields: 'PL' },
  { id: 'PV1.4', description: 'Admission Type', subfields: 'IS' },
  { id: 'PV1.5', description: 'Preadmit Number', subfields: 'CX' },
  { id: 'PV1.6', description: 'Prior Patient Location', subfields: 'PL' },
  { id: 'PV1.7', description: 'Attending Doctor', subfields: 'XCN' },
  { id: 'PV1.8', description: 'Referring Doctor', subfields: 'XCN' },
  { id: 'PV1.9', description: 'Consulting Doctor', subfields: 'XCN' },
  { id: 'PV1.10', description: 'Hospital Service', subfields: 'IS' },
  { id: 'PV1.11', description: 'Temporary Location', subfields: 'PL' },
  { id: 'PV1.12', description: 'Preadmit Test Indicator', subfields: 'IS' },
  { id: 'PV1.13', description: 'Re-admission Indicator', subfields: 'IS' },
  { id: 'PV1.14', description: 'Admit Source', subfields: 'IS' },
  { id: 'PV1.15', description: 'Ambulatory Status', subfields: 'IS' },
  { id: 'PV1.16', description: 'VIP Indicator', subfields: 'IS' },
  { id: 'PV1.17', description: 'Admitting Doctor', subfields: 'XCN' },
  { id: 'PV1.18', description: 'Patient Type', subfields: 'IS' },
  { id: 'PV1.19', description: 'Visit Number', subfields: 'CX' },
  { id: 'PV1.20', description: 'Financial Class', subfields: 'FC' },
  { id: 'PV1.21', description: 'Charge Price Indicator', subfields: 'IS' },
  { id: 'PV1.22', description: 'Courtesy Code', subfields: 'IS' },
  { id: 'PV1.23', description: 'Credit Rating', subfields: 'IS' },
  { id: 'PV1.24', description: 'Contract Code', subfields: 'IS' },
  { id: 'PV1.25', description: 'Contract Effective Date', subfields: 'DT' },
  { id: 'PV1.26', description: 'Contract Amount', subfields: 'NM' },
  { id: 'PV1.27', description: 'Contract Period', subfields: 'NM' },
  { id: 'PV1.28', description: 'Interest Code', subfields: 'IS' },
  { id: 'PV1.29', description: 'Transfer to Bad Debt Code', subfields: 'IS' },
  { id: 'PV1.30', description: 'Transfer to Bad Debt Date', subfields: 'DT' },
  { id: 'PV1.31', description: 'Bad Debt Agency Code', subfields: 'IS' },
  { id: 'PV1.32', description: 'Bad Debt Transfer Amount', subfields: 'NM' },
  { id: 'PV1.33', description: 'Bad Debt Recovery Amount', subfields: 'NM' },
  { id: 'PV1.34', description: 'Delete Account Indicator', subfields: 'IS' },
  { id: 'PV1.35', description: 'Delete Account Date', subfields: 'DT' },
  { id: 'PV1.36', description: 'Discharge Disposition', subfields: 'IS' },
  { id: 'PV1.37', description: 'Discharged to Location', subfields: 'DLD' },
  { id: 'PV1.38', description: 'Diet Type', subfields: 'CE' },
  { id: 'PV1.39', description: 'Servicing Facility', subfields: 'IS' },
  { id: 'PV1.40', description: 'Bed Status', subfields: 'IS' },
  { id: 'PV1.41', description: 'Account Status', subfields: 'IS' },
  { id: 'PV1.42', description: 'Pending Location', subfields: 'PL' },
  { id: 'PV1.43', description: 'Prior Temporary Location', subfields: 'PL' },
  { id: 'PV1.44', description: 'Admit Date/Time', subfields: 'TS' },
  { id: 'PV1.45', description: 'Discharge Date/Time', subfields: 'TS' },
  { id: 'PV1.46', description: 'Current Patient Balance', subfields: 'NM' },
  { id: 'PV1.47', description: 'Total Charges', subfields: 'NM' },
  { id: 'PV1.48', description: 'Total Adjustments', subfields: 'NM' },
  { id: 'PV1.49', description: 'Total Payments', subfields: 'NM' },
  { id: 'PV1.50', description: 'Alternate Visit ID', subfields: 'CX' },
  { id: 'PV1.51', description: 'Visit Indicator', subfields: 'IS' },
  { id: 'PV1.52', description: 'Other Healthcare Provider', subfields: 'XCN' },
  { id: 'PV2.1', description: 'Prior Pending Location', subfields: 'PL' },
  { id: 'PV2.2', description: 'Accommodation Code', subfields: 'CE' },
  { id: 'PV2.3', description: 'Admit Reason', subfields: 'CE' },
  { id: 'PV2.4', description: 'Transfer Reason', subfields: 'CE' },
  { id: 'PV2.5', description: 'Patient Valuables', subfields: 'ST' },
  { id: 'PV2.6', description: 'Patient Valuables Location', subfields: 'ST' },
  { id: 'PV2.7', description: 'Visit User Code', subfields: 'IS' },
  { id: 'PV2.8', description: 'Expected Admit Date/Time', subfields: 'TS' },
  { id: 'PV2.9', description: 'Expected Discharge Date/Time', subfields: 'TS' },
  {
    id: 'PV2.10',
    description: 'Estimated Length of Inpatient Stay',
    subfields: 'NM',
  },
  {
    id: 'PV2.11',
    description: 'Actual Length of Inpatient Stay',
    subfields: 'NM',
  },
  { id: 'PV2.12', description: 'Visit Description', subfields: 'ST' },
  { id: 'PV2.13', description: 'Referral Source Code', subfields: 'XCN' },
  { id: 'PV2.14', description: 'Previous Service Date', subfields: 'DT' },
  {
    id: 'PV2.15',
    description: 'Employment Illness Related Indicator',
    subfields: 'ID',
  },
  { id: 'PV2.16', description: 'Purge Status Code', subfields: 'IS' },
  { id: 'PV2.17', description: 'Purge Status Date', subfields: 'DT' },
  { id: 'PV2.18', description: 'Special Program Code', subfields: 'IS' },
  { id: 'PV2.19', description: 'Retention Indicator', subfields: 'ID' },
  {
    id: 'PV2.20',
    description: 'Expected Number of Insurance Plans',
    subfields: 'NM',
  },
  { id: 'PV2.21', description: 'Visit Publicity Code', subfields: 'IS' },
  { id: 'PV2.22', description: 'Visit Protection Indicator', subfields: 'ID' },
  { id: 'PV2.23', description: 'Clinic Organization Name', subfields: 'XON' },
  { id: 'PV2.24', description: 'Patient Status Code', subfields: 'IS' },
  { id: 'PV2.25', description: 'Visit Priority Code', subfields: 'IS' },
  { id: 'PV2.26', description: 'Previous Treatment Date', subfields: 'DT' },
  {
    id: 'PV2.27',
    description: 'Expected Discharge Disposition',
    subfields: 'IS',
  },
  { id: 'PV2.28', description: 'Signature on File Date', subfields: 'DT' },
  { id: 'PV2.29', description: 'First Similar Illness Date', subfields: 'DT' },
  {
    id: 'PV2.30',
    description: 'Patient Charge Adjustment Code',
    subfields: 'CE',
  },
  { id: 'PV2.31', description: 'Recurring Service Code', subfields: 'IS' },
  { id: 'PV2.32', description: 'Billing Media Code', subfields: 'ID' },
  {
    id: 'PV2.33',
    description: 'Expected Surgery Date and Time',
    subfields: 'TS',
  },
  { id: 'PV2.34', description: 'Military Partnership Code', subfields: 'ID' },
  {
    id: 'PV2.35',
    description: 'Military Non-Availability Code',
    subfields: 'ID',
  },
  { id: 'PV2.36', description: 'Newborn Baby Indicator', subfields: 'ID' },
  { id: 'PV2.37', description: 'Baby Detained Indicator', subfields: 'ID' },
  { id: 'PV2.38', description: 'Mode of Arrival Code', subfields: 'CE' },
  { id: 'PV2.39', description: 'Recreational Drug Use Code', subfields: 'CE' },
  {
    id: 'PV2.40',
    description: 'Admission Level of Care Code',
    subfields: 'CE',
  },
  { id: 'PV2.41', description: 'Precaution Code', subfields: 'CE' },
  { id: 'PV2.42', description: 'Patient Condition Code', subfields: 'CE' },
  { id: 'PV2.43', description: 'Living Will Code', subfields: 'IS' },
  { id: 'PV2.44', description: 'Organ Donor Code', subfields: 'IS' },
  { id: 'PV2.45', description: 'Advance Directive Code', subfields: 'CE' },
  {
    id: 'PV2.46',
    description: 'Patient Status Effective Date',
    subfields: 'DT',
  },
  {
    id: 'PV2.47',
    description: 'Expected LOA Return Date/Time',
    subfields: 'TS',
  },
  {
    id: 'PV2.48',
    description: 'Expected Pre-admission Testing Date/Time',
    subfields: 'TS',
  },
  { id: 'PV2.49', description: 'Notify Clergy Code', subfields: 'IS' },
  { id: 'QAK.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'QAK.2', description: 'Query Response Status', subfields: 'ID' },
  { id: 'QAK.3', description: 'Message Query Name', subfields: 'CE' },
  { id: 'QAK.4', description: 'Hit Count', subfields: 'NM' },
  { id: 'QAK.5', description: 'This payload', subfields: 'NM' },
  { id: 'QAK.6', description: 'Hits remaining', subfields: 'NM' },
  { id: 'QID.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'QID.2', description: 'Message Query Name', subfields: 'CE' },
  { id: 'QPD.1', description: 'Message Query Name', subfields: 'CE' },
  { id: 'QPD.2', description: 'Query Tag', subfields: 'ST' },
  {
    id: 'QPD.3',
    description: 'User Parameters (in successive fields)',
    subfields: 'var',
  },
  { id: 'QRD.1', description: 'Query Date/Time', subfields: 'TS' },
  { id: 'QRD.2', description: 'Query Format Code', subfields: 'ID' },
  { id: 'QRD.3', description: 'Query Priority', subfields: 'ID' },
  { id: 'QRD.4', description: 'Query ID', subfields: 'ST' },
  { id: 'QRD.5', description: 'Deferred Response Type', subfields: 'ID' },
  { id: 'QRD.6', description: 'Deferred Response Date/Time', subfields: 'TS' },
  { id: 'QRD.7', description: 'Quantity Limited Request', subfields: 'CQ' },
  { id: 'QRD.8', description: 'Who Subject Filter', subfields: 'XCN' },
  { id: 'QRD.9', description: 'What Subject Filter', subfields: 'CE' },
  { id: 'QRD.10', description: 'What Department Data Code', subfields: 'CE' },
  { id: 'QRD.11', description: 'What Data Code Value Qual.', subfields: 'VR' },
  { id: 'QRD.12', description: 'Query Results Level', subfields: 'ID' },
  { id: 'QRF.1', description: 'Where Subject Filter', subfields: 'ST' },
  { id: 'QRF.2', description: 'When Data Start Date/Time', subfields: 'TS' },
  { id: 'QRF.3', description: 'When Data End Date/Time', subfields: 'TS' },
  { id: 'QRF.4', description: 'What User Qualifier', subfields: 'ST' },
  { id: 'QRF.5', description: 'Other QRY Subject Filter', subfields: 'ST' },
  { id: 'QRF.6', description: 'Which Date/Time Qualifier', subfields: 'ID' },
  {
    id: 'QRF.7',
    description: 'Which Date/Time Status Qualifier',
    subfields: 'ID',
  },
  {
    id: 'QRF.8',
    description: 'Date/Time Selection Qualifier',
    subfields: 'ID',
  },
  {
    id: 'QRF.9',
    description: 'When Quantity/Timing Qualifier',
    subfields: 'TQ',
  },
  { id: 'QRF.10', description: 'Search Confidence Threshold', subfields: 'NM' },
  { id: 'QRI.1', description: 'Candidate Confidence', subfields: 'NM' },
  { id: 'QRI.2', description: 'Match Reason Code', subfields: 'IS' },
  { id: 'QRI.3', description: 'Algorithm Descriptor', subfields: 'CE' },
  { id: 'RCP.1', description: 'Query Priority', subfields: 'ID' },
  { id: 'RCP.2', description: 'Quantity Limited Request', subfields: 'CQ' },
  { id: 'RCP.3', description: 'Response Modality', subfields: 'CE' },
  { id: 'RCP.4', description: 'Execution and Delivery Time', subfields: 'TS' },
  { id: 'RCP.5', description: 'Modify Indicator', subfields: 'ID' },
  { id: 'RCP.6', description: 'Sort-by Field', subfields: 'SRT' },
  { id: 'RCP.7', description: 'Segment group inclusion', subfields: 'ID' },
  { id: 'RDF.1', description: 'Number of Columns per Row', subfields: 'NM' },
  { id: 'RDF.2', description: 'Column Description', subfields: 'RCD' },
  { id: 'RDT.1', description: 'Column Value', subfields: 'var' },
  { id: 'RF1.1', description: 'Referral Status', subfields: 'CE' },
  { id: 'RF1.2', description: 'Referral Priority', subfields: 'CE' },
  { id: 'RF1.3', description: 'Referral Type', subfields: 'CE' },
  { id: 'RF1.4', description: 'Referral Disposition', subfields: 'CE' },
  { id: 'RF1.5', description: 'Referral Category', subfields: 'CE' },
  {
    id: 'RF1.6',
    description: 'Originating Referral Identifier',
    subfields: 'EI',
  },
  { id: 'RF1.7', description: 'Effective Date', subfields: 'TS' },
  { id: 'RF1.8', description: 'Expiration Date', subfields: 'TS' },
  { id: 'RF1.9', description: 'Process Date', subfields: 'TS' },
  { id: 'RF1.10', description: 'Referral Reason', subfields: 'CE' },
  {
    id: 'RF1.11',
    description: 'External Referral Identifier',
    subfields: 'EI',
  },
  { id: 'RGS.1', description: 'Set ID - RGS', subfields: 'SI' },
  { id: 'RGS.2', description: 'Segment Action Code', subfields: 'ID' },
  { id: 'RGS.3', description: 'Resource Group ID', subfields: 'CE' },
  {
    id: 'RMI.1',
    description: 'Risk Management Incident Code',
    subfields: 'CE',
  },
  { id: 'RMI.2', description: 'Date/Time Incident', subfields: 'TS' },
  { id: 'RMI.3', description: 'Incident Type Code', subfields: 'CE' },
  { id: 'ROL.1', description: 'Role Instance ID', subfields: 'EI' },
  { id: 'ROL.2', description: 'Action Code', subfields: 'ID' },
  { id: 'ROL.3', description: 'Role-ROL', subfields: 'CE' },
  { id: 'ROL.4', description: 'Role Person', subfields: 'XCN' },
  { id: 'ROL.5', description: 'Role Begin Date/Time', subfields: 'TS' },
  { id: 'ROL.6', description: 'Role End Date/Time', subfields: 'TS' },
  { id: 'ROL.7', description: 'Role Duration', subfields: 'CE' },
  { id: 'ROL.8', description: 'Role Action Reason', subfields: 'CE' },
  { id: 'ROL.9', description: 'Provider Type', subfields: 'CE' },
  { id: 'ROL.10', description: 'Organization Unit Type', subfields: 'CE' },
  {
    id: 'ROL.11',
    description: 'Office/Home Address/Birthplace',
    subfields: 'XAD',
  },
  { id: 'ROL.12', description: 'Phone', subfields: 'XTN' },
  { id: 'RQ1.1', description: 'Anticipated Price', subfields: 'ST' },
  { id: 'RQ1.2', description: 'Manufacturer Identifier', subfields: 'CE' },
  { id: 'RQ1.3', description: "Manufacturer's Catalog", subfields: 'ST' },
  { id: 'RQ1.4', description: 'Vendor ID', subfields: 'CE' },
  { id: 'RQ1.5', description: 'Vendor Catalog', subfields: 'ST' },
  { id: 'RQ1.6', description: 'Taxable', subfields: 'ID' },
  { id: 'RQ1.7', description: 'Substitute Allowed', subfields: 'ID' },
  { id: 'RQD.1', description: 'Requisition Line Number', subfields: 'SI' },
  { id: 'RQD.2', description: 'Item Code - Internal', subfields: 'CE' },
  { id: 'RQD.3', description: 'Item Code - External', subfields: 'CE' },
  { id: 'RQD.4', description: 'Hospital Item Code', subfields: 'CE' },
  { id: 'RQD.5', description: 'Requisition Quantity', subfields: 'NM' },
  { id: 'RQD.6', description: 'Requisition Unit of Measure', subfields: 'CE' },
  { id: 'RQD.7', description: 'Dept. Cost Center', subfields: 'IS' },
  { id: 'RQD.8', description: 'Item Natural Account Code', subfields: 'IS' },
  { id: 'RQD.9', description: 'Deliver To ID', subfields: 'CE' },
  { id: 'RQD.10', description: 'Date Needed', subfields: 'DT' },
  { id: 'RXA.1', description: 'Give Sub-ID Counter', subfields: 'NM' },
  {
    id: 'RXA.2',
    description: 'Administration Sub-ID Counter',
    subfields: 'NM',
  },
  {
    id: 'RXA.3',
    description: 'Date/Time Start of Administration',
    subfields: 'TS',
  },
  {
    id: 'RXA.4',
    description: 'Date/Time End of Administration',
    subfields: 'TS',
  },
  { id: 'RXA.5', description: 'Administered Code', subfields: 'CE' },
  { id: 'RXA.6', description: 'Administered Amount', subfields: 'NM' },
  { id: 'RXA.7', description: 'Administered Units', subfields: 'CE' },
  { id: 'RXA.8', description: 'Administered Dosage Form', subfields: 'CE' },
  { id: 'RXA.9', description: 'Administration Notes', subfields: 'CE' },
  { id: 'RXA.10', description: 'Administering Provider', subfields: 'XCN' },
  { id: 'RXA.11', description: 'Administered-at Location', subfields: 'LA2' },
  {
    id: 'RXA.12',
    description: 'Administered Per (Time Unit)',
    subfields: 'ST',
  },
  { id: 'RXA.13', description: 'Administered Strength', subfields: 'NM' },
  { id: 'RXA.14', description: 'Administered Strength Units', subfields: 'CE' },
  { id: 'RXA.15', description: 'Substance Lot Number', subfields: 'ST' },
  { id: 'RXA.16', description: 'Substance Expiration Date', subfields: 'TS' },
  { id: 'RXA.17', description: 'Substance Manufacturer Name', subfields: 'CE' },
  {
    id: 'RXA.18',
    description: 'Substance/Treatment Refusal Reason',
    subfields: 'CE',
  },
  { id: 'RXA.19', description: 'Indication', subfields: 'CE' },
  { id: 'RXA.20', description: 'Completion Status', subfields: 'ID' },
  { id: 'RXA.21', description: 'Action Code - RXA', subfields: 'ID' },
  { id: 'RXA.22', description: 'System Entry Date/Time', subfields: 'TS' },
  {
    id: 'RXA.23',
    description: 'Administered Drug Strength Volume',
    subfields: 'NM',
  },
  {
    id: 'RXA.24',
    description: 'Administered Drug Strength Volume Units',
    subfields: 'CWE',
  },
  {
    id: 'RXA.25',
    description: 'Administered Barcode Identifier',
    subfields: 'CWE',
  },
  { id: 'RXA.26', description: 'Pharmacy Order Type', subfields: 'ID' },
  { id: 'RXC.1', description: 'RX Component Type', subfields: 'ID' },
  { id: 'RXC.2', description: 'Component Code', subfields: 'CE' },
  { id: 'RXC.3', description: 'Component Amount', subfields: 'NM' },
  { id: 'RXC.4', description: 'Component Units', subfields: 'CE' },
  { id: 'RXC.5', description: 'Component Strength', subfields: 'NM' },
  { id: 'RXC.6', description: 'Component Strength Units', subfields: 'CE' },
  { id: 'RXC.7', description: 'Supplementary Code', subfields: 'CE' },
  {
    id: 'RXC.8',
    description: 'Component Drug Strength Volume',
    subfields: 'NM',
  },
  {
    id: 'RXC.9',
    description: 'Component Drug Strength Volume Units',
    subfields: 'CWE',
  },
  { id: 'RXD.1', description: 'Dispense Sub-ID Counter', subfields: 'NM' },
  { id: 'RXD.2', description: 'Dispense/Give Code', subfields: 'CE' },
  { id: 'RXD.3', description: 'Date/Time Dispensed', subfields: 'TS' },
  { id: 'RXD.4', description: 'Actual Dispense Amount', subfields: 'NM' },
  { id: 'RXD.5', description: 'Actual Dispense Units', subfields: 'CE' },
  { id: 'RXD.6', description: 'Actual Dosage Form', subfields: 'CE' },
  { id: 'RXD.7', description: 'Prescription Number', subfields: 'ST' },
  { id: 'RXD.8', description: 'Number of Refills Remaining', subfields: 'NM' },
  { id: 'RXD.9', description: 'Dispense Notes', subfields: 'ST' },
  { id: 'RXD.10', description: 'Dispensing Provider', subfields: 'XCN' },
  { id: 'RXD.11', description: 'Substitution Status', subfields: 'ID' },
  { id: 'RXD.12', description: 'Total Daily Dose', subfields: 'CQ' },
  { id: 'RXD.13', description: 'Dispense-to Location', subfields: 'LA2' },
  { id: 'RXD.14', description: 'Needs Human Review', subfields: 'ID' },
  {
    id: 'RXD.15',
    description:
      "Pharmacy/Treatment Supplier's Special Dispensing Instructions",
    subfields: 'CE',
  },
  { id: 'RXD.16', description: 'Actual Strength', subfields: 'NM' },
  { id: 'RXD.17', description: 'Actual Strength Unit', subfields: 'CE' },
  { id: 'RXD.18', description: 'Substance Lot Number', subfields: 'ST' },
  { id: 'RXD.19', description: 'Substance Expiration Date', subfields: 'TS' },
  { id: 'RXD.20', description: 'Substance Manufacturer Name', subfields: 'CE' },
  { id: 'RXD.21', description: 'Indication', subfields: 'CE' },
  { id: 'RXD.22', description: 'Dispense Package Size', subfields: 'NM' },
  { id: 'RXD.23', description: 'Dispense Package Size Unit', subfields: 'CE' },
  { id: 'RXD.24', description: 'Dispense Package Method', subfields: 'ID' },
  { id: 'RXD.25', description: 'Supplementary Code', subfields: 'CE' },
  { id: 'RXD.26', description: 'Initiating Location', subfields: 'CE' },
  { id: 'RXD.27', description: 'Packaging/Assembly Location', subfields: 'CE' },
  { id: 'RXD.28', description: 'Actual Drug Strength Volume', subfields: 'NM' },
  {
    id: 'RXD.29',
    description: 'Actual Drug Strength Volume Units',
    subfields: 'CWE',
  },
  { id: 'RXD.30', description: 'Dispense to Pharmacy', subfields: 'CWE' },
  {
    id: 'RXD.31',
    description: 'Dispense to Pharmacy Address',
    subfields: 'XAD',
  },
  { id: 'RXD.32', description: 'Pharmacy Order Type', subfields: 'ID' },
  { id: 'RXD.33', description: 'Dispense Type', subfields: 'CWE' },
  { id: 'RXE.1', description: 'Quantity/Timing', subfields: 'TQ' },
  { id: 'RXE.2', description: 'Give Code', subfields: 'CE' },
  { id: 'RXE.3', description: 'Give Amount - Minimum', subfields: 'NM' },
  { id: 'RXE.4', description: 'Give Amount - Maximum', subfields: 'NM' },
  { id: 'RXE.5', description: 'Give Units', subfields: 'CE' },
  { id: 'RXE.6', description: 'Give Dosage Form', subfields: 'CE' },
  {
    id: 'RXE.7',
    description: "Provider's Administration Instructions",
    subfields: 'CE',
  },
  { id: 'RXE.8', description: 'Deliver-To Location', subfields: 'LA1' },
  { id: 'RXE.9', description: 'Substitution Status', subfields: 'ID' },
  { id: 'RXE.10', description: 'Dispense Amount', subfields: 'NM' },
  { id: 'RXE.11', description: 'Dispense Units', subfields: 'CE' },
  { id: 'RXE.12', description: 'Number Of Refills', subfields: 'NM' },
  {
    id: 'RXE.13',
    description: "Ordering Provider's DEA Number",
    subfields: 'XCN',
  },
  {
    id: 'RXE.14',
    description: "Pharmacist/Treatment Supplier's Verifier ID",
    subfields: 'XCN',
  },
  { id: 'RXE.15', description: 'Prescription Number', subfields: 'ST' },
  { id: 'RXE.16', description: 'Number of Refills Remaining', subfields: 'NM' },
  {
    id: 'RXE.17',
    description: 'Number of Refills/Doses Dispensed',
    subfields: 'NM',
  },
  {
    id: 'RXE.18',
    description: 'D/T of Most Recent Refill or Dose Dispensed',
    subfields: 'TS',
  },
  { id: 'RXE.19', description: 'Total Daily Dose', subfields: 'CQ' },
  { id: 'RXE.20', description: 'Needs Human Review', subfields: 'ID' },
  {
    id: 'RXE.21',
    description:
      "Pharmacy/Treatment Supplier's Special Dispensing Instructions",
    subfields: 'CE',
  },
  { id: 'RXE.22', description: 'Give Per (Time Unit)', subfields: 'ST' },
  { id: 'RXE.23', description: 'Give Rate Amount', subfields: 'ST' },
  { id: 'RXE.24', description: 'Give Rate Units', subfields: 'CE' },
  { id: 'RXE.25', description: 'Give Strength', subfields: 'NM' },
  { id: 'RXE.26', description: 'Give Strength Units', subfields: 'CE' },
  { id: 'RXE.27', description: 'Give Indication', subfields: 'CE' },
  { id: 'RXE.28', description: 'Dispense Package Size', subfields: 'NM' },
  { id: 'RXE.29', description: 'Dispense Package Size Unit', subfields: 'CE' },
  { id: 'RXE.30', description: 'Dispense Package Method', subfields: 'ID' },
  { id: 'RXE.31', description: 'Supplementary Code', subfields: 'CE' },
  { id: 'RXE.32', description: 'Original Order Date/Time', subfields: 'TS' },
  { id: 'RXE.33', description: 'Give Drug Strength Volume', subfields: 'NM' },
  {
    id: 'RXE.34',
    description: 'Give Drug Strength Volume Units',
    subfields: 'CWE',
  },
  {
    id: 'RXE.35',
    description: 'Controlled Substance Schedule',
    subfields: 'CWE',
  },
  { id: 'RXE.36', description: 'Formulary Status', subfields: 'ID' },
  {
    id: 'RXE.37',
    description: 'Pharmaceutical Substance Alternative',
    subfields: 'CWE',
  },
  {
    id: 'RXE.38',
    description: 'Pharmacy of Most Recent Fill',
    subfields: 'CWE',
  },
  { id: 'RXE.39', description: 'Initial Dispense Amount', subfields: 'NM' },
  { id: 'RXE.40', description: 'Dispensing Pharmacy', subfields: 'CWE' },
  {
    id: 'RXE.41',
    description: 'Dispensing Pharmacy Address',
    subfields: 'XAD',
  },
  { id: 'RXE.42', description: 'Deliver-to Patient Location', subfields: 'PL' },
  { id: 'RXE.43', description: 'Deliver-to Address', subfields: 'XAD' },
  { id: 'RXE.44', description: 'Pharmacy Order Type', subfields: 'ID' },
  { id: 'RXG.1', description: 'Give Sub-ID Counter', subfields: 'NM' },
  { id: 'RXG.2', description: 'Dispense Sub-ID Counter', subfields: 'NM' },
  { id: 'RXG.3', description: 'Quantity/Timing', subfields: 'TQ' },
  { id: 'RXG.4', description: 'Give Code', subfields: 'CE' },
  { id: 'RXG.5', description: 'Give Amount - Minimum', subfields: 'NM' },
  { id: 'RXG.6', description: 'Give Amount - Maximum', subfields: 'NM' },
  { id: 'RXG.7', description: 'Give Units', subfields: 'CE' },
  { id: 'RXG.8', description: 'Give Dosage Form', subfields: 'CE' },
  { id: 'RXG.9', description: 'Administration Notes', subfields: 'CE' },
  { id: 'RXG.10', description: 'Substitution Status', subfields: 'ID' },
  { id: 'RXG.11', description: 'Dispense-to Location', subfields: 'LA2' },
  { id: 'RXG.12', description: 'Needs Human Review', subfields: 'ID' },
  {
    id: 'RXG.13',
    description:
      "Pharmacy/Treatment Supplier's Special Administration Instructions",
    subfields: 'CE',
  },
  { id: 'RXG.14', description: 'Give Per (Time Unit)', subfields: 'ST' },
  { id: 'RXG.15', description: 'Give Rate Amount', subfields: 'ST' },
  { id: 'RXG.16', description: 'Give Rate Units', subfields: 'CE' },
  { id: 'RXG.17', description: 'Give Strength', subfields: 'NM' },
  { id: 'RXG.18', description: 'Give Strength Units', subfields: 'CE' },
  { id: 'RXG.19', description: 'Substance Lot Number', subfields: 'ST' },
  { id: 'RXG.20', description: 'Substance Expiration Date', subfields: 'TS' },
  { id: 'RXG.21', description: 'Substance Manufacturer Name', subfields: 'CE' },
  { id: 'RXG.22', description: 'Indication', subfields: 'CE' },
  { id: 'RXG.23', description: 'Give Drug Strength Volume', subfields: 'NM' },
  {
    id: 'RXG.24',
    description: 'Give Drug Strength Volume Units',
    subfields: 'CWE',
  },
  { id: 'RXG.25', description: 'Give Barcode Identifier', subfields: 'CWE' },
  { id: 'RXG.26', description: 'Pharmacy Order Type', subfields: 'ID' },
  { id: 'RXO.1', description: 'Requested Give Code', subfields: 'CE' },
  {
    id: 'RXO.2',
    description: 'Requested Give Amount - Minimum',
    subfields: 'NM',
  },
  {
    id: 'RXO.3',
    description: 'Requested Give Amount - Maximum',
    subfields: 'NM',
  },
  { id: 'RXO.4', description: 'Requested Give Units', subfields: 'CE' },
  { id: 'RXO.5', description: 'Requested Dosage Form', subfields: 'CE' },
  {
    id: 'RXO.6',
    description: "Provider's Pharmacy/Treatment Instructions",
    subfields: 'CE',
  },
  {
    id: 'RXO.7',
    description: "Provider's Administration Instructions",
    subfields: 'CE',
  },
  { id: 'RXO.8', description: 'Deliver-To Location', subfields: 'LA1' },
  { id: 'RXO.9', description: 'Allow Substitutions', subfields: 'ID' },
  { id: 'RXO.10', description: 'Requested Dispense Code', subfields: 'CE' },
  { id: 'RXO.11', description: 'Requested Dispense Amount', subfields: 'NM' },
  { id: 'RXO.12', description: 'Requested Dispense Units', subfields: 'CE' },
  { id: 'RXO.13', description: 'Number Of Refills', subfields: 'NM' },
  {
    id: 'RXO.14',
    description: "Ordering Provider's DEA Number",
    subfields: 'XCN',
  },
  {
    id: 'RXO.15',
    description: "Pharmacist/Treatment Supplier's Verifier ID",
    subfields: 'XCN',
  },
  { id: 'RXO.16', description: 'Needs Human Review', subfields: 'ID' },
  {
    id: 'RXO.17',
    description: 'Requested Give Per (Time Unit)',
    subfields: 'ST',
  },
  { id: 'RXO.18', description: 'Requested Give Strength', subfields: 'NM' },
  {
    id: 'RXO.19',
    description: 'Requested Give Strength Units',
    subfields: 'CE',
  },
  { id: 'RXO.20', description: 'Indication', subfields: 'CE' },
  { id: 'RXO.21', description: 'Requested Give Rate Amount', subfields: 'ST' },
  { id: 'RXO.22', description: 'Requested Give Rate Units', subfields: 'CE' },
  { id: 'RXO.23', description: 'Total Daily Dose', subfields: 'CQ' },
  { id: 'RXO.24', description: 'Supplementary Code', subfields: 'CE' },
  {
    id: 'RXO.25',
    description: 'Requested Drug Strength Volume',
    subfields: 'NM',
  },
  {
    id: 'RXO.26',
    description: 'Requested Drug Strength Volume Units',
    subfields: 'CWE',
  },
  { id: 'RXO.27', description: 'Pharmacy Order Type', subfields: 'ID' },
  { id: 'RXO.28', description: 'Dispensing Interval', subfields: 'NM' },
  { id: 'RXR.1', description: 'Route', subfields: 'CE' },
  { id: 'RXR.2', description: 'Administration Site', subfields: 'CWE' },
  { id: 'RXR.3', description: 'Administration Device', subfields: 'CE' },
  { id: 'RXR.4', description: 'Administration Method', subfields: 'CWE' },
  { id: 'RXR.5', description: 'Routing Instruction', subfields: 'CE' },
  {
    id: 'RXR.6',
    description: 'Administration Site Modifier',
    subfields: 'CWE',
  },
  {
    id: 'SAC.1',
    description: 'External Accession Identifier',
    subfields: 'EI',
  },
  { id: 'SAC.2', description: 'Accession Identifier', subfields: 'EI' },
  { id: 'SAC.3', description: 'Container Identifier', subfields: 'EI' },
  {
    id: 'SAC.4',
    description: 'Primary (parent) Container Identifier',
    subfields: 'EI',
  },
  {
    id: 'SAC.5',
    description: 'Equipment Container Identifier',
    subfields: 'EI',
  },
  { id: 'SAC.6', description: 'Specimen Source', subfields: 'SPS' },
  { id: 'SAC.7', description: 'Registration Date/Time', subfields: 'TS' },
  { id: 'SAC.8', description: 'Container Status', subfields: 'CE' },
  { id: 'SAC.9', description: 'Carrier Type', subfields: 'CE' },
  { id: 'SAC.10', description: 'Carrier Identifier', subfields: 'EI' },
  { id: 'SAC.11', description: 'Position in Carrier', subfields: 'NA' },
  { id: 'SAC.12', description: 'Tray Type - SAC', subfields: 'CE' },
  { id: 'SAC.13', description: 'Tray Identifier', subfields: 'EI' },
  { id: 'SAC.14', description: 'Position in Tray', subfields: 'NA' },
  { id: 'SAC.15', description: 'Location', subfields: 'CE' },
  { id: 'SAC.16', description: 'Container Height', subfields: 'NM' },
  { id: 'SAC.17', description: 'Container Diameter', subfields: 'NM' },
  { id: 'SAC.18', description: 'Barrier Delta', subfields: 'NM' },
  { id: 'SAC.19', description: 'Bottom Delta', subfields: 'NM' },
  {
    id: 'SAC.20',
    description: 'Container Height/Diameter/Delta Units',
    subfields: 'CE',
  },
  { id: 'SAC.21', description: 'Container Volume', subfields: 'NM' },
  { id: 'SAC.22', description: 'Available Specimen Volume', subfields: 'NM' },
  { id: 'SAC.23', description: 'Initial Specimen Volume', subfields: 'NM' },
  { id: 'SAC.24', description: 'Volume Units', subfields: 'CE' },
  { id: 'SAC.25', description: 'Separator Type', subfields: 'CE' },
  { id: 'SAC.26', description: 'Cap Type', subfields: 'CE' },
  { id: 'SAC.27', description: 'Additive', subfields: 'CWE' },
  { id: 'SAC.28', description: 'Specimen Component', subfields: 'CE' },
  { id: 'SAC.29', description: 'Dilution Factor', subfields: 'SN' },
  { id: 'SAC.30', description: 'Treatment', subfields: 'CE' },
  { id: 'SAC.31', description: 'Temperature', subfields: 'SN' },
  { id: 'SAC.32', description: 'Hemolysis Index', subfields: 'NM' },
  { id: 'SAC.33', description: 'Hemolysis Index Units', subfields: 'CE' },
  { id: 'SAC.34', description: 'Lipemia Index', subfields: 'NM' },
  { id: 'SAC.35', description: 'Lipemia Index Units', subfields: 'CE' },
  { id: 'SAC.36', description: 'Icterus Index', subfields: 'NM' },
  { id: 'SAC.37', description: 'Icterus Index Units', subfields: 'CE' },
  { id: 'SAC.38', description: 'Fibrin Index', subfields: 'NM' },
  { id: 'SAC.39', description: 'Fibrin Index Units', subfields: 'CE' },
  { id: 'SAC.40', description: 'System Induced Contaminants', subfields: 'CE' },
  { id: 'SAC.41', description: 'Drug Interference', subfields: 'CE' },
  { id: 'SAC.42', description: 'Artificial Blood', subfields: 'CE' },
  { id: 'SAC.43', description: 'Special Handling Code', subfields: 'CWE' },
  { id: 'SAC.44', description: 'Other Environmental Factors', subfields: 'CE' },
  { id: 'SCH.1', description: 'Placer Appointment ID', subfields: 'EI' },
  { id: 'SCH.2', description: 'Filler Appointment ID', subfields: 'EI' },
  { id: 'SCH.3', description: 'Occurrence Number', subfields: 'NM' },
  { id: 'SCH.4', description: 'Placer Group Number', subfields: 'EI' },
  { id: 'SCH.5', description: 'Schedule ID', subfields: 'CE' },
  { id: 'SCH.6', description: 'Event Reason', subfields: 'CE' },
  { id: 'SCH.7', description: 'Appointment Reason', subfields: 'CE' },
  { id: 'SCH.8', description: 'Appointment Type', subfields: 'CE' },
  { id: 'SCH.9', description: 'Appointment Duration', subfields: 'NM' },
  { id: 'SCH.10', description: 'Appointment Duration Units', subfields: 'CE' },
  { id: 'SCH.11', description: 'Appointment Timing Quantity', subfields: 'TQ' },
  { id: 'SCH.12', description: 'Placer Contact Person', subfields: 'XCN' },
  {
    id: 'SCH.13',
    description: 'Placer Contact Phone Number',
    subfields: 'XTN',
  },
  { id: 'SCH.14', description: 'Placer Contact Address', subfields: 'XAD' },
  { id: 'SCH.15', description: 'Placer Contact Location', subfields: 'PL' },
  { id: 'SCH.16', description: 'Filler Contact Person', subfields: 'XCN' },
  {
    id: 'SCH.17',
    description: 'Filler Contact Phone Number',
    subfields: 'XTN',
  },
  { id: 'SCH.18', description: 'Filler Contact Address', subfields: 'XAD' },
  { id: 'SCH.19', description: 'Filler Contact Location', subfields: 'PL' },
  { id: 'SCH.20', description: 'Entered By Person', subfields: 'XCN' },
  { id: 'SCH.21', description: 'Entered By Phone Number', subfields: 'XTN' },
  { id: 'SCH.22', description: 'Entered By Location', subfields: 'PL' },
  {
    id: 'SCH.23',
    description: 'Parent Placer Appointment ID',
    subfields: 'EI',
  },
  {
    id: 'SCH.24',
    description: 'Parent Filler Appointment ID',
    subfields: 'EI',
  },
  { id: 'SCH.25', description: 'Filler Status Code', subfields: 'CE' },
  { id: 'SCH.26', description: 'Placer Order Number', subfields: 'EI' },
  { id: 'SCH.27', description: 'Filler Order Number', subfields: 'EI' },
  {
    id: 'SFT.1',
    description: 'Software Vendor Organization',
    subfields: 'XON',
  },
  {
    id: 'SFT.2',
    description: 'Software Certified Version or Release Number',
    subfields: 'ST',
  },
  { id: 'SFT.3', description: 'Software Product Name', subfields: 'ST' },
  { id: 'SFT.4', description: 'Software Binary ID', subfields: 'ST' },
  { id: 'SFT.5', description: 'Software Product Information', subfields: 'TX' },
  { id: 'SFT.6', description: 'Software Install Date', subfields: 'TS' },
  {
    id: 'SID.1',
    description: 'Application / Method Identifier',
    subfields: 'CE',
  },
  { id: 'SID.2', description: 'Substance Lot Number', subfields: 'ST' },
  {
    id: 'SID.3',
    description: 'Substance Container Identifier',
    subfields: 'ST',
  },
  {
    id: 'SID.4',
    description: 'Substance Manufacturer Identifier',
    subfields: 'CE',
  },
  { id: 'SPM.1', description: 'Set ID - SPM', subfields: 'SI' },
  { id: 'SPM.2', description: 'Specimen ID', subfields: 'EIP' },
  { id: 'SPM.3', description: 'Specimen Parent IDs', subfields: 'EIP' },
  { id: 'SPM.4', description: 'Specimen Type', subfields: 'CWE' },
  { id: 'SPM.5', description: 'Specimen Type Modifier', subfields: 'CWE' },
  { id: 'SPM.6', description: 'Specimen Additives', subfields: 'CWE' },
  { id: 'SPM.7', description: 'Specimen Collection Method', subfields: 'CWE' },
  { id: 'SPM.8', description: 'Specimen Source Site', subfields: 'CWE' },
  {
    id: 'SPM.9',
    description: 'Specimen Source Site Modifier',
    subfields: 'CWE',
  },
  { id: 'SPM.10', description: 'Specimen Collection Site', subfields: 'CWE' },
  { id: 'SPM.11', description: 'Specimen Role', subfields: 'CWE' },
  { id: 'SPM.12', description: 'Specimen Collection Amount', subfields: 'CQ' },
  { id: 'SPM.13', description: 'Grouped Specimen Count', subfields: 'NM' },
  { id: 'SPM.14', description: 'Specimen Description', subfields: 'ST' },
  { id: 'SPM.15', description: 'Specimen Handling Code', subfields: 'CWE' },
  { id: 'SPM.16', description: 'Specimen Risk Code', subfields: 'CWE' },
  {
    id: 'SPM.17',
    description: 'Specimen Collection Date/Time',
    subfields: 'DR',
  },
  { id: 'SPM.18', description: 'Specimen Received Date/Time', subfields: 'TS' },
  {
    id: 'SPM.19',
    description: 'Specimen Expiration Date/Time',
    subfields: 'TS',
  },
  { id: 'SPM.20', description: 'Specimen Availability', subfields: 'ID' },
  { id: 'SPM.21', description: 'Specimen Reject Reason', subfields: 'CWE' },
  { id: 'SPM.22', description: 'Specimen Quality', subfields: 'CWE' },
  { id: 'SPM.23', description: 'Specimen Appropriateness', subfields: 'CWE' },
  { id: 'SPM.24', description: 'Specimen Condition', subfields: 'CWE' },
  { id: 'SPM.25', description: 'Specimen Current Quantity', subfields: 'CQ' },
  {
    id: 'SPM.26',
    description: 'Number of Specimen Containers',
    subfields: 'NM',
  },
  { id: 'SPM.27', description: 'Container Type', subfields: 'CWE' },
  { id: 'SPM.28', description: 'Container Condition', subfields: 'CWE' },
  { id: 'SPM.29', description: 'Specimen Child Role', subfields: 'CWE' },
  { id: 'SPR.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'SPR.2', description: 'Query/Response Format Code', subfields: 'ID' },
  { id: 'SPR.3', description: 'Stored Procedure Name', subfields: 'CE' },
  { id: 'SPR.4', description: 'Input Parameter List', subfields: 'QIP' },
  { id: 'STF.1', description: 'Primary Key Value - STF', subfields: 'CE' },
  { id: 'STF.2', description: 'Staff Identifier List', subfields: 'CX' },
  { id: 'STF.3', description: 'Staff Name', subfields: 'XPN' },
  { id: 'STF.4', description: 'Staff Type', subfields: 'IS' },
  { id: 'STF.5', description: 'Administrative Sex', subfields: 'IS' },
  { id: 'STF.6', description: 'Date/Time of Birth', subfields: 'TS' },
  { id: 'STF.7', description: 'Active/Inactive Flag', subfields: 'ID' },
  { id: 'STF.8', description: 'Department', subfields: 'CE' },
  { id: 'STF.9', description: 'Hospital Service - STF', subfields: 'CE' },
  { id: 'STF.10', description: 'Phone', subfields: 'XTN' },
  {
    id: 'STF.11',
    description: 'Office/Home Address/Birthplace',
    subfields: 'XAD',
  },
  {
    id: 'STF.12',
    description: 'Institution Activation Date',
    subfields: 'DIN',
  },
  {
    id: 'STF.13',
    description: 'Institution Inactivation Date',
    subfields: 'DIN',
  },
  { id: 'STF.14', description: 'Backup Person ID', subfields: 'CE' },
  { id: 'STF.15', description: 'E-Mail Address', subfields: 'ST' },
  { id: 'STF.16', description: 'Preferred Method of Contact', subfields: 'CE' },
  { id: 'STF.17', description: 'Marital Status', subfields: 'CE' },
  { id: 'STF.18', description: 'Job Title', subfields: 'ST' },
  { id: 'STF.19', description: 'Job Code/Class', subfields: 'JCC' },
  { id: 'STF.20', description: 'Employment Status Code', subfields: 'CE' },
  { id: 'STF.21', description: 'Additional Insured on Auto', subfields: 'ID' },
  {
    id: 'STF.22',
    description: "Driver's License Number - Staff",
    subfields: 'DLN',
  },
  { id: 'STF.23', description: 'Copy Auto Ins', subfields: 'ID' },
  { id: 'STF.24', description: 'Auto Ins. Expires', subfields: 'DT' },
  { id: 'STF.25', description: 'Date Last DMV Review', subfields: 'DT' },
  { id: 'STF.26', description: 'Date Next DMV Review', subfields: 'DT' },
  { id: 'STF.27', description: 'Race', subfields: 'CE' },
  { id: 'STF.28', description: 'Ethnic Group', subfields: 'CE' },
  {
    id: 'STF.29',
    description: 'Re-activation Approval Indicator',
    subfields: 'ID',
  },
  { id: 'STF.30', description: 'Citizenship', subfields: 'CE' },
  { id: 'STF.31', description: 'Death Date and Time', subfields: 'TS' },
  { id: 'STF.32', description: 'Death Indicator', subfields: 'ID' },
  {
    id: 'STF.33',
    description: 'Institution Relationship Type Code',
    subfields: 'CWE',
  },
  {
    id: 'STF.34',
    description: 'Institution Relationship Period',
    subfields: 'DR',
  },
  { id: 'STF.35', description: 'Expected Return Date', subfields: 'DT' },
  { id: 'STF.36', description: 'Cost Center Code', subfields: 'CWE' },
  {
    id: 'STF.37',
    description: 'Generic Classification Indicator',
    subfields: 'ID',
  },
  { id: 'STF.38', description: 'Inactive Reason Code', subfields: 'CWE' },
  { id: 'TCC.1', description: 'Universal Service Identifier', subfields: 'CE' },
  { id: 'TCC.2', description: 'Test Application Identifier', subfields: 'EI' },
  { id: 'TCC.3', description: 'Specimen Source', subfields: 'SPS' },
  { id: 'TCC.4', description: 'Auto-Dilution Factor Default', subfields: 'SN' },
  {
    id: 'TCC.5',
    description: 'Rerun Dilution Factor Default',
    subfields: 'SN',
  },
  { id: 'TCC.6', description: 'Pre-Dilution Factor Default', subfields: 'SN' },
  {
    id: 'TCC.7',
    description: 'Endogenous Content of Pre-Dilution Diluent',
    subfields: 'SN',
  },
  {
    id: 'TCC.8',
    description: 'Inventory Limits Warning Level',
    subfields: 'NM',
  },
  { id: 'TCC.9', description: 'Automatic Rerun Allowed', subfields: 'ID' },
  { id: 'TCC.10', description: 'Automatic Repeat Allowed', subfields: 'ID' },
  { id: 'TCC.11', description: 'Automatic Reflex Allowed', subfields: 'ID' },
  { id: 'TCC.12', description: 'Equipment Dynamic Range', subfields: 'SN' },
  { id: 'TCC.13', description: 'Units', subfields: 'CE' },
  { id: 'TCC.14', description: 'Processing Type', subfields: 'CE' },
  { id: 'TCD.1', description: 'Universal Service Identifier', subfields: 'CE' },
  { id: 'TCD.2', description: 'Auto-Dilution Factor', subfields: 'SN' },
  { id: 'TCD.3', description: 'Rerun Dilution Factor', subfields: 'SN' },
  { id: 'TCD.4', description: 'Pre-Dilution Factor', subfields: 'SN' },
  {
    id: 'TCD.5',
    description: 'Endogenous Content of Pre-Dilution Diluent',
    subfields: 'SN',
  },
  { id: 'TCD.6', description: 'Automatic Repeat Allowed', subfields: 'ID' },
  { id: 'TCD.7', description: 'Reflex Allowed', subfields: 'ID' },
  { id: 'TCD.8', description: 'Analyte Repeat Status', subfields: 'CE' },
  { id: 'TQ1.1', description: 'Set ID - TQ1', subfields: 'SI' },
  { id: 'TQ1.2', description: 'Quantity', subfields: 'CQ' },
  { id: 'TQ1.3', description: 'Repeat Pattern', subfields: 'RPT' },
  { id: 'TQ1.4', description: 'Explicit Time', subfields: 'TM' },
  { id: 'TQ1.5', description: 'Relative Time and Units', subfields: 'CQ' },
  { id: 'TQ1.6', description: 'Service Duration', subfields: 'CQ' },
  { id: 'TQ1.7', description: 'Start date/time', subfields: 'TS' },
  { id: 'TQ1.8', description: 'End date/time', subfields: 'TS' },
  { id: 'TQ1.9', description: 'Priority', subfields: 'CWE' },
  { id: 'TQ1.10', description: 'Condition text', subfields: 'TX' },
  { id: 'TQ1.11', description: 'Text instruction', subfields: 'TX' },
  { id: 'TQ1.12', description: 'Conjunction', subfields: 'ID' },
  { id: 'TQ1.13', description: 'Occurrence duration', subfields: 'CQ' },
  { id: 'TQ1.14', description: "Total occurrence's", subfields: 'NM' },
  { id: 'TQ2.1', description: 'Set ID - TQ2', subfields: 'SI' },
  { id: 'TQ2.2', description: 'Sequence/Results Flag', subfields: 'ID' },
  { id: 'TQ2.3', description: 'Related Placer Number', subfields: 'EI' },
  { id: 'TQ2.4', description: 'Related Filler Number', subfields: 'EI' },
  { id: 'TQ2.5', description: 'Related Placer Group Number', subfields: 'EI' },
  { id: 'TQ2.6', description: 'Sequence Condition Code', subfields: 'ID' },
  { id: 'TQ2.7', description: 'Cyclic Entry/Exit Indicator', subfields: 'ID' },
  {
    id: 'TQ2.8',
    description: 'Sequence Condition Time Interval',
    subfields: 'CQ',
  },
  {
    id: 'TQ2.9',
    description: 'Cyclic Group Maximum Number of Repeats',
    subfields: 'NM',
  },
  {
    id: 'TQ2.10',
    description: 'Special Service Request Relationship',
    subfields: 'ID',
  },
  { id: 'TXA.1', description: 'Set ID - TXA', subfields: 'SI' },
  { id: 'TXA.2', description: 'Document Type', subfields: 'IS' },
  {
    id: 'TXA.3',
    description: 'Document Content Presentation',
    subfields: 'ID',
  },
  { id: 'TXA.4', description: 'Activity Date/Time', subfields: 'TS' },
  {
    id: 'TXA.5',
    description: 'Primary Activity Provider Code/Name',
    subfields: 'XCN',
  },
  { id: 'TXA.6', description: 'Origination Date/Time', subfields: 'TS' },
  { id: 'TXA.7', description: 'Transcription Date/Time', subfields: 'TS' },
  { id: 'TXA.8', description: 'Edit Date/Time', subfields: 'TS' },
  { id: 'TXA.9', description: 'Originator Code/Name', subfields: 'XCN' },
  {
    id: 'TXA.10',
    description: 'Assigned Document Authenticator',
    subfields: 'XCN',
  },
  { id: 'TXA.11', description: 'Transcriptionist Code/Name', subfields: 'XCN' },
  { id: 'TXA.12', description: 'Unique Document Number', subfields: 'EI' },
  { id: 'TXA.13', description: 'Parent Document Number', subfields: 'EI' },
  { id: 'TXA.14', description: 'Placer Order Number', subfields: 'EI' },
  { id: 'TXA.15', description: 'Filler Order Number', subfields: 'EI' },
  { id: 'TXA.16', description: 'Unique Document File Name', subfields: 'ST' },
  { id: 'TXA.17', description: 'Document Completion Status', subfields: 'ID' },
  {
    id: 'TXA.18',
    description: 'Document Confidentiality Status',
    subfields: 'ID',
  },
  {
    id: 'TXA.19',
    description: 'Document Availability Status',
    subfields: 'ID',
  },
  { id: 'TXA.20', description: 'Document Storage Status', subfields: 'ID' },
  { id: 'TXA.21', description: 'Document Change Reason', subfields: 'ST' },
  {
    id: 'TXA.22',
    description: 'Authentication Person, Time Stamp',
    subfields: 'PPN',
  },
  {
    id: 'TXA.23',
    description: 'Distributed Copies (Code and Name of Recipients)',
    subfields: 'XCN',
  },
  { id: 'UB1.1', description: 'Set ID - UB1', subfields: 'SI' },
  { id: 'UB1.2', description: 'Blood Deductible  (43)', subfields: 'NM' },
  {
    id: 'UB1.3',
    description: 'Blood Furnished-Pints Of (40)',
    subfields: 'NM',
  },
  { id: 'UB1.4', description: 'Blood Replaced-Pints (41)', subfields: 'NM' },
  { id: 'UB1.5', description: 'Blood Not Replaced-Pints(42)', subfields: 'NM' },
  { id: 'UB1.6', description: 'Co-Insurance Days (25)', subfields: 'NM' },
  { id: 'UB1.7', description: 'Condition Code (35-39)', subfields: 'IS' },
  { id: 'UB1.8', description: 'Covered Days - (23)', subfields: 'NM' },
  { id: 'UB1.9', description: 'Non Covered Days - (24)', subfields: 'NM' },
  {
    id: 'UB1.10',
    description: 'Value Amount & Code (46-49)',
    subfields: 'UVC',
  },
  { id: 'UB1.11', description: 'Number Of Grace Days (90)', subfields: 'NM' },
  {
    id: 'UB1.12',
    description: 'Special Program Indicator (44)',
    subfields: 'CE',
  },
  {
    id: 'UB1.13',
    description: 'PSRO/UR Approval Indicator (87)',
    subfields: 'CE',
  },
  {
    id: 'UB1.14',
    description: 'PSRO/UR Approved Stay-Fm (88)',
    subfields: 'DT',
  },
  {
    id: 'UB1.15',
    description: 'PSRO/UR Approved Stay-To (89)',
    subfields: 'DT',
  },
  { id: 'UB1.16', description: 'Occurrence (28-32)', subfields: 'OCD' },
  { id: 'UB1.17', description: 'Occurrence Span (33)', subfields: 'CE' },
  { id: 'UB1.18', description: 'Occur Span Start Date(33)', subfields: 'DT' },
  { id: 'UB1.19', description: 'Occur Span End Date (33)', subfields: 'DT' },
  { id: 'UB1.20', description: 'UB-82 Locator 2', subfields: 'ST' },
  { id: 'UB1.21', description: 'UB-82 Locator 9', subfields: 'ST' },
  { id: 'UB1.22', description: 'UB-82 Locator 27', subfields: 'ST' },
  { id: 'UB1.23', description: 'UB-82 Locator 45', subfields: 'ST' },
  { id: 'UB2.1', description: 'Set ID - UB2', subfields: 'SI' },
  { id: 'UB2.2', description: 'Co-Insurance Days (9)', subfields: 'ST' },
  { id: 'UB2.3', description: 'Condition Code (24-30)', subfields: 'IS' },
  { id: 'UB2.4', description: 'Covered Days (7)', subfields: 'ST' },
  { id: 'UB2.5', description: 'Non-Covered Days (8)', subfields: 'ST' },
  { id: 'UB2.6', description: 'Value Amount & Code', subfields: 'UVC' },
  {
    id: 'UB2.7',
    description: 'Occurrence Code & Date (32-35)',
    subfields: 'OCD',
  },
  {
    id: 'UB2.8',
    description: 'Occurrence Span Code/Dates (36)',
    subfields: 'OSP',
  },
  { id: 'UB2.9', description: 'UB92 Locator 2 (State)', subfields: 'ST' },
  { id: 'UB2.10', description: 'UB92 Locator 11 (State)', subfields: 'ST' },
  { id: 'UB2.11', description: 'UB92 Locator 31 (National)', subfields: 'ST' },
  { id: 'UB2.12', description: 'Document Control Number', subfields: 'ST' },
  { id: 'UB2.13', description: 'UB92 Locator 49 (National)', subfields: 'ST' },
  { id: 'UB2.14', description: 'UB92 Locator 56 (State)', subfields: 'ST' },
  { id: 'UB2.15', description: 'UB92 Locator 57 (National)', subfields: 'ST' },
  { id: 'UB2.16', description: 'UB92 Locator 78 (State)', subfields: 'ST' },
  { id: 'UB2.17', description: 'Special Visit Count', subfields: 'NM' },
  { id: 'URD.1', description: 'R/U Date/Time', subfields: 'TS' },
  { id: 'URD.2', description: 'Report Priority', subfields: 'ID' },
  { id: 'URD.3', description: 'R/U Who Subject Definition', subfields: 'XCN' },
  { id: 'URD.4', description: 'R/U What Subject Definition', subfields: 'CE' },
  { id: 'URD.5', description: 'R/U What Department Code', subfields: 'CE' },
  { id: 'URD.6', description: 'R/U Display/Print Locations', subfields: 'ST' },
  { id: 'URD.7', description: 'R/U Results Level', subfields: 'ID' },
  { id: 'URS.1', description: 'R/U Where Subject Definition', subfields: 'ST' },
  {
    id: 'URS.2',
    description: 'R/U When Data Start Date/Time',
    subfields: 'TS',
  },
  { id: 'URS.3', description: 'R/U When Data End Date/Time', subfields: 'TS' },
  { id: 'URS.4', description: 'R/U What User Qualifier', subfields: 'ST' },
  {
    id: 'URS.5',
    description: 'R/U Other Results Subject Definition',
    subfields: 'ST',
  },
  {
    id: 'URS.6',
    description: 'R/U Which Date/Time Qualifier',
    subfields: 'ID',
  },
  {
    id: 'URS.7',
    description: 'R/U Which Date/Time Status Qualifier',
    subfields: 'ID',
  },
  {
    id: 'URS.8',
    description: 'R/U Date/Time Selection Qualifier',
    subfields: 'ID',
  },
  {
    id: 'URS.9',
    description: 'R/U Quantity/Timing Qualifier',
    subfields: 'TQ',
  },
  { id: 'VAR.1', description: 'Variance Instance ID', subfields: 'EI' },
  { id: 'VAR.2', description: 'Documented Date/Time', subfields: 'TS' },
  { id: 'VAR.3', description: 'Stated Variance Date/Time', subfields: 'TS' },
  { id: 'VAR.4', description: 'Variance Originator', subfields: 'XCN' },
  { id: 'VAR.5', description: 'Variance Classification', subfields: 'CE' },
  { id: 'VAR.6', description: 'Variance Description', subfields: 'ST' },
  { id: 'VTQ.1', description: 'Query Tag', subfields: 'ST' },
  { id: 'VTQ.2', description: 'Query/Response Format Code', subfields: 'ID' },
  { id: 'VTQ.3', description: 'VT Query Name', subfields: 'CE' },
  { id: 'VTQ.4', description: 'Virtual Table Name', subfields: 'CE' },
  { id: 'VTQ.5', description: 'Selection Criteria', subfields: 'QSC' },
];
